export const resources = {
  "pt-BR": {
    translation: {
      shapefileForeman: {
        phoneInUse: "Telefone já está sendo utilizado.",
        title: "Capataz",
        help: "Escolha ou cadastre o capataz desta fazenda. Ele será preenchido como responsável pelos retiros e poderá ser alterado em cada formulário.",
        useExisting: "Utilizar capataz cadastrado",
        createNew: "Cadastrar novo capataz",
        select: "Selecione um capataz",
        selectRequired: "Selecione um capataz para continuar.",
        empty: "Nenhum capataz cadastrado. Escolha cadastrar um novo.",
        createHelp:
          "O usuário será cadastrado junto com o shapefile ao confirmar o cadastro.",
      },
      shapefileImport: {
        profileName: "Nome",
        profileRole: "Cargo/Função",
        profilePhone: "Telefone",
        profilePassword: "Senha padrão",
        profilesToCreate: "Perfis a serem criados ({{count}})",
        defaultPassword: "Senha padrão: {{password}}",
        noNewProfiles: "Nenhum novo perfil será criado.",
        successTitle: "Cadastro concluído",
        successMessage: "O cadastro do shapefile foi concluído com sucesso.",
        errorTitle: "Não foi possível concluir o cadastro",
        errorMessage:
          "Não foi possível cadastrar o shapefile. Tente novamente.",
        submitting: "Enviando...",
        ok: "OK",
        otherSteps: "Outras etapas",
        importStep: "Importação",
        reviewStep: "Confirmação",
        title: "Shapefile",
        uploadHelp:
          "Importe o arquivo e revise as fazendas, retiros e pastos antes de confirmar o cadastro.",
        steps: "Etapas da importação",
        loadingUsers: "Carregando responsáveis...",
        loadError: "Não foi possível carregar os responsáveis cadastrados.",
        noUsers:
          "Cadastre responsáveis em Perfis antes de importar o Shapefile.",
        retry: "Tentar novamente",
        noFarms: "O arquivo não contém fazendas para importar.",
        summary: "Fazendas, retiros e pastos ({{count}})",
        confirm: "Confirmar cadastro",
      },
      onboardingProperty: {
        manual: "Manual",
        addArea: "+ ADICIONAR RETIRO",
        addPaddock: "+ ADICIONAR PASTO",
        farmMap: "Fazenda",
        areaMaps: "Retiros ({{count}})",
        paddockMaps: "Pastos ({{count}})",
      },
      pastureMap: {
        title: "Mapa das fazendas",
        overview: "Todas as fazendas",
        navigation: "Focar fazenda no mapa",
        farmCount: "{{count}} fazendas selecionadas",
        farmCount_one: "{{count}} fazenda selecionada",
        farmCount_other: "{{count}} fazendas selecionadas",
        noCoordinates:
          "Esta seleção não possui coordenadas para exibir no mapa.",
        noFarms: "Selecione uma ou mais fazendas para visualizar o mapa.",
        heightAxis: "Altura (cm)",
        stripAxis: "Nº de faixas",
      },

      multiDropdown: {
        selectedCount: "{{count}} selecionados",
        remove: "Remover {{name}}",
      },
      reportLayout: {
        allBatches: "Todos os lotes",
        selectFilters: "Selecione fazendas e retiros",
        filters: "Filtros",
        farms: "Fazendas",
        areas: "Retiros",
        period: "Período",
        updating: "Atualizando relatório…",
        ready: "Dados atualizados",
        error: "Não foi possível atualizar o relatório",
        retry: "Tentar novamente",
        none: "Nenhum selecionado",
        download: "Exportar relatório",
        report: "Relatório",
      },
      supplementationExport: {
        creepFeeding: "Creep-feeding",
        yes: "Sim",
        no: "Não",
        mode: "Modalidade",
        normal: "Salga normal",
        creep: "Creep-feeding",
        unknown: "Não informado",
        products: "Produto utilizado",
        classifications: "Linha de suplementação",
        quantityKg: "Quantidade (kg)",
        bags: "Equivalente em sacos",
      },
      language: {
        label: "Idioma",
        portuguese: "Português",
        spanish: "Espanhol",
      },
      session: {
        title: "Faça seu login.",
        phone: "Telefone",
        password: "Senha",
        invalidCredentials: "Credenciais inválidas",
        forgotPassword: "Esqueceu sua senha?",
        forgotInstructions:
          "Entre em contato com o seu Administrador da fazenda.",
        back: "VOLTAR",
        continue: "Continuar",
        login: "Login",
        validation: {
          phone: "*Telefone informado inválido!",
          required: "*Campo obrigatório não informado.",
        },
      },
      navigation: {
        reports: "Relatórios",
        cattleMap: "Mapa de Gado",
        general: "Geral",
        batches: "Lotes",
        supplementation: "Suplementação",
        inventoryControl: "Controle de estoque",
        consumptionAnalysis: "Análise de consumo",
        monthlyConsumption: "Consumo por mês",
        pastureManagement: "Manejo de Pasto",
        byManagementGroup: "Por grupo de manejo",
        carbon: "Carbono",
        stocking: "Lotação",
        instantStocking: "Lotação instantânea",
        averageStocking: "Lotação média",
        occupationAndRest: "Dias de ocupação e descanso",
        management: "Manejo",
        managementType: "Tipo de manejo",
        height: "Altura",
        rating: "Nota",
        days: "Dias",
        createTasks: "Criar tarefas",
        requests: "Solicitações",
        takeInventory: "Realizar inventário",
        manageSystem: "Gerenciar sistema",
        logout: "Sair",
        version: "Versão {{version}}",
        debugToggle:
          "Versão {{version}}. Pressione Shift e clique cinco vezes para alternar o modo debug.",
      },
      apiErrors: { invalidCredentials: "Credenciais inválidas" },
      dateFilter: {
        title: "Definir período",
        start: "Data de início:",
        end: "Data de fim:",
        from: "De",
        to: "Até",
        filterAria: "Filtrar por período",
        cancel: "Cancelar",
        apply: "Aplicar",
      },
      mapLegend: {
        occupationDays: "Dias de ocupação",
        restDays: "Dias de descanso",
        averageStocking: "LOTAÇÃO MÉDIA (UA/HA)",
        instantStocking: "LOTAÇÃO INSTANTÂNEA (UA/HA)",
        management: "Manejo",
        continuous: "Contínuo",
        rotational: "Rotacionado",
        strip: "Em faixa",
        noMonitoring: "Sem monitoramento",
        height: "Altura",
        aboveHeight: "Acima da altura",
        withinRange: "Dentro do intervalo",
        belowHeight: "Abaixo da altura",
        noHeight: "Sem altura atribuída",
        referenceRating: "Seleção de nota de referência",
        rating: "Nota",
        aboveRating: "Acima da nota",
        belowRating: "Abaixo da nota",
        noRating: "Sem nota atribuída",
        aboveOccupationDays: "Acima dos dias de ocupação",
        belowOccupationDays: "Abaixo dos dias de ocupação",
      },
      ratingScale: {
        bare: "Rapado",
        exitPoint: "Ponto de saída",
        grazingPoint: "Ponto de pastejo",
        entryPoint: "Ponto de entrada",
        overgrown: "Passando",
      },
      systemManager: {
        shapefile: "Shapefile",
        title: "Gerenciar sistema",
        registrations: "Cadastros",
        propertiesAreas: "Propriedades e Áreas",
        profiles: "Perfis",
        monitoring: "Monitoramentos",
        taskMonitoring: "Monitoramento de tarefas",
        pastureEvaluation: "Avaliação de pastagem",
        animals: "Animais",
        batches: "Lotes",
        pastureManagement: "Manejo de Pasto",
        categoriesWeights: "Categorias e pesos",
        batchLabels: "Etiquetas de lotes",
        supplementation: "Suplementação",
        salters: "Salgadores",
        products: "Produtos",
        stock: "Estoque",
        farms: "Fazendas",
        areas: "Retiros",
        paddocks: "Pastos",
        animalCategory: "Categoria Animal",
        weights: "Pesos",
        farm: "Fazenda",
        area: "Retiro",
        paddock: "Pasto",
        batch: "Lote",
        selectFarm: "Selecione a fazenda",
        all: "Todos",
        evaluated: "Avaliado",
        archived: "Arquivados",
        canceled: "Cancelados",
        pending: "Pendente",
        completed: "Concluído",
        syncFailure: "Falha de sincronismo",
        notifications: "Notificações",
        height: "Altura",
        days: "Dias",
        rating: "Nota",
        strip: "Faixa",
        startEvaluation: "Iniciar avaliação",
        active: "Ativos",
        inactive: "Inativos",
        searchSalters: "Nome, telefone, fazenda, retiro ou sigla",
        phoneUnavailable: "Telefone não informado",
        farmCount_one: "Fazenda",
        farmCount_other: "Fazendas",
        areaCount_one: "Retiro",
        areaCount_other: "Retiros",
        noResults: "Nenhum resultado encontrado.",
        titles: {
          inventory: "Realizar inventário",
          createProduct: "Cadastro de produto",
          manageEvaluators: "Gerenciar avaliadores",
          syncFailures: "Falhas de sincronismo",
          requests: "Solicitações",
        },
        forms: {
          createFarm: "Cadastro de Fazenda",
          editFarm: "Edição de Fazenda",
          createArea: "Cadastro de Retiro",
          editArea: "Edição de Retiro",
          createPaddock: "Cadastro de Pasto",
          editPaddock: "Edição de Pasto",
          createBatch: "Criação de Lotes",
          editBatch: "Edição de Lote",
          editProduct: "Edição de Produto",
          createManagement: "Cadastro de Manejo de Pasto",
          editManagement: "Edição de Manejo de Pasto",
          createEvaluator: "Cadastro de Avaliador",
          editEvaluator: "Edição de Avaliador",
          downloadEvaluation: "Baixar avaliação",
          viewInventory: "Visualizar inventário",
          linkSalter: "Vincular Salgador",
          editSalter: "Editar Salgador",
        },
      },
      taskMonitoring: {
        statuses: {
          completed: "Concluído",
          pending: "Pendente",
          accepted: "Aceito",
          canceled: "Cancelado",
          error: "Erro",
        },
        details: {
          liveOrSlaughter: "Vivo ou para abate?",
          live: "Vivo",
          slaughter: "Abate",
        },
        tasks: {
          updateBatch: "Atualizar lote",
          splitBatch: "Dividir lote",
          evolveCategory: "Evoluir categoria",
          moveBatch: "Movimentar lote",
          mergeBatches: "Junção de lotes",
          updateGrazingRoute: "Atualizar rota de pastejo",
          transferBatch: "Transferência de Lote",
          rainfallCollection: "Coleta de pluviometria",
          fertilization: "Adubação",
          waterTrough: "Bebedouro",
          fence: "Cerca",
          detached: "Tarefa avulsa",
          contour: "Curva de nível",
          planting: "Plantio",
          soilPreparation: "Preparo de solo",
          spraying: "Pulverização",
          productIncoming: "Recebimento do produto",
          productDispatch: "Saída do produto",
          brushCutting: "Roçagem",
          collectInformation: "Coleta de Informações",
          stripMovement: "Movimentação de Faixa",
          birth: "Nascimento",
          purchase: "Compra",
          sale: "Venda",
          slaughter: "Abate",
          death: "Morte",
          forcedInventoryEntry: "Ajuste de Inventário Entrada Forçado",
          forcedInventoryExit: "Ajuste de Inventário Saída Forçado",
          inventoryEntry: "Ajuste de Inventário Entrada",
          inventoryExit: "Ajuste de Inventário Saída",
          batchInventoryAdjustment: "Ajuste de Inventário em Lote",
        },
      },
      batchCreation: {
        initialsLoading: "Consultando a próxima sigla do retiro…",
        initialsUnavailable:
          "Não foi possível sugerir uma sigla disponível. Informe a sigla manualmente.",
      },
      batchLabel: {
        field: "Etiqueta do lote",
        placeholder: "Selecione...",
        clear: "Limpar seleção",
        unavailable: "Não foi possível carregar as etiquetas do lote.",
        stamp: "Carimbo",
        stampPlaceholder: "Selecione um carimbo",
        invalidLabel: "Selecione uma etiqueta válida.",
        stampRequired: "Selecione um carimbo válido.",
        invalidStamp: "O carimbo selecionado não está disponível.",
        updateInvalid:
          "Não foi possível atualizar a etiqueta. Verifique a seleção ou se o lote está ativo.",
        updateForbidden:
          "Você não tem permissão para alterar a etiqueta deste lote.",
        updateNotFound: "Este lote não foi encontrado.",
        updateError:
          "Não foi possível atualizar a etiqueta do lote. Tente novamente.",
      },
      batchLabelsManagement: {
        searchLabel: "Pesquisar pelo nome da etiqueta ou pelo nome ou sigla da fazenda e do retiro",
        searchPlaceholder: "Pesquisar Etiqueta, Fazenda e Retiro...",
        noSearchResults: "Nenhuma etiqueta encontrada para a pesquisa.",
        create: "Cadastrar etiqueta",
        labelName: "Nome da etiqueta",
        stampColumn: "Carimbo",
        batchCountColumn: "Lotes",
        batchCount_other: "{{formattedCount}} lotes",
        unused: "Não utilizado",
        batchesTooltip_other: "{{count}} lotes: {{initials}}",
        catalog: "Catálogo de etiquetas",
        count_one: "{{count}} etiqueta cadastrada",
        count_other: "{{count}} etiquetas cadastradas",
        labelColumn: "Etiqueta",
        stampYes: "Sim",
        stampNo: "Não",
        formHelp: "Informe o nome da etiqueta e indique se terá carimbo.",
        hasStamp: "Terá carimbo",
        requiredName: "Informe o nome da etiqueta.",
        nameTooLong: "O nome deve ter até 255 caracteres.",
        invalid: "Verifique os dados da etiqueta.",
        forbidden: "Você não tem permissão para cadastrar etiquetas.",
        createError: "Não foi possível cadastrar a etiqueta. Tente novamente.",
        save: "Cadastrar",
        saving: "Cadastrando...",
        cancel: "Cancelar",
        close: "Fechar cadastro de etiqueta",
        created: "Etiqueta cadastrada com sucesso.",
        loading: "Carregando etiquetas...",
        loadError: "Não foi possível carregar as etiquetas.",
        retry: "Tentar novamente",
        empty: "Nenhuma etiqueta cadastrada.",
        actions: "Ações",
        edit: "Editar etiqueta",
        editLabel: "Editar etiqueta {{name}}",
        deleteLabel: "Excluir etiqueta {{name}}",
        closeEdit: "Fechar edição de etiqueta",
        editHelp:
          "Altere o nome ou a disponibilidade de carimbo. O nome salvo será usado em português e espanhol.",
        saveChanges: "Salvar alterações",
        updating: "Salvando alterações...",
        updated: "Etiqueta atualizada com sucesso.",
        editInvalid: "Verifique os dados da etiqueta.",
        editConflict:
          "Não é possível alterar o carimbo desta etiqueta enquanto ela estiver associada a um lote ativo.",
        editError: "Não foi possível atualizar a etiqueta. Tente novamente.",
        manageForbidden: "Você não tem permissão para alterar etiquetas.",
        notFound: "Esta etiqueta não foi encontrada.",
        deleteTitle: "Excluir etiqueta",
        deleteHelp:
          "Excluir a etiqueta {{name}} do catálogo? Ela permanecerá nos lotes associados e no histórico.",
        confirmDelete: "Excluir etiqueta",
        deleting: "Excluindo...",
        deleted: "Etiqueta excluída do catálogo.",
        deleteError: "Não foi possível excluir a etiqueta. Tente novamente.",
      },
      formsV2: {
        creepFeeding: "Usado em creep-feeding",
        productSummary: {
          consumption: "{{value}} g/kg de PV",
          creepFeeding: "Creep-feeding",
          yes: "Sim",
          no: "Não",
          bagWeight: "Peso por saco",
          frequency: "{{frequency}} x por semana",
        },
        cancel: "Cancelar",
        save: "Salvar",
        saveChanges: "Salvar",
        confirm: "Confirmar",
        add: "Adicionar",
        export: "Exportar",
        farm: "Fazenda",
        farms: "Fazendas",
        area: "Retiro",
        areas: "Retiros",
        paddock: "Pasto",
        paddocks: "Pastos",
        batch: "Lote",
        initials: "Sigla",
        mapCoordinates: "Coordenadas do mapa",
        usefulArea: "Área útil",
        totalArea: "Área total",
        farmName: "Nome da Fazenda",
        stateRegistration: "Inscrição Estadual",
        state: "UF",
        city: "Cidade",
        farmManager: "Responsável da Fazenda",
        seasonDefinition: "Definição de Estação",
        rainySeasonStart: "Início das chuvas",
        drySeasonStart: "Início da seca",
        areaName: "Nome do Retiro",
        maxTimeWithCattle: "Tempo Máximo COM gado",
        maxTimeWithoutCattle: "Tempo Máximo SEM gado",
        areaManager: "Responsável do Retiro",
        unusedReason: "Motivo para não utilizar o pasto",
        currentPaddock: "Pasto atual",
        category: "Categoria",
        totalUa: "UA total",
        noPaddocks: "Não existem pastos disponíveis",
        weightParametersRequired:
          "Necessário realizar o cadastro dos parâmetros de pesos",
        productTradeName: "Nome comercial do produto",
        manufacturer: "Fabricante",
        classification: "Classificação",
        subClassification: "Sub classificação",
        packagingType: "Tipo de acondicionamento",
        packagingBagged: "Sacaria",
        packagingBulk: "A granel",
        bagWeight: "Peso do saco",
        expectedConsumption: "Consumo esperado",
        supplyFrequency: "Frequência de fornecimento",
        timesPerWeek: "x por semana",
        frequencies: {
          weekly: "Semanal",
          biweekly: "Bisemanal",
          monthly: "Mensal",
        },
        saltType: "Tipo de sal",
        expectedConsumptionClassification: "Classificação de consumo esperado",
        role: "Cargo/Função",
        userName: "Nome de Usuário",
        mobilePhone: "Telefone Celular",
        user: "Usuário",
        farmSelectDescription:
          "Selecionar uma fazenda também seleciona todos os retiros vinculados a ela.",
        selectFarmOrArea: "Selecione pelo menos uma fazenda ou um retiro.",
        saveSalterError: "Não foi possível salvar o salgador.",
        responsible: "Responsável",
        selectResponsible: "Selecionar responsável...",
        noResponsible: "Nenhum responsável disponível",
        selectArea: "Selecionar retiro...",
        selectPaddocks: "Selecionar pastos...",
        noFarms: "Nenhuma fazenda disponível",
        noAreas: "Nenhum retiro disponível",
        noPaddocksAvailable: "Nenhum pasto disponível",
        responsibleRequired: "Responsável é necessário.",
        areaRequired: "Retiro é necessário.",
        paddocksRequired: "Pastos são necessários.",
        paddocksMap: "Mapa dos pastos",
        paddocksMapHelp:
          "Selecione um ou mais pastos para visualizar seus polígonos.",
        globalReport: "Relatório global",
        paddockReport: "Relatório por pasto",
        model: "Modelo",
        selectFarm: "Selecionar fazenda...",
        selectAreas: "Selecionar retiros...",
        selectModel: "Selecionar modelo...",
        noModel: "Nenhum modelo disponível",
        farmRequired: "Fazenda é necessária.",
        areasRequired: "Retiros são necessários.",
        modelRequired: "Modelo é necessário.",
        reportError: "Não foi possível renderizar o relatório.",
        reportPreview: "Pré-visualização do relatório",
        evaluationPreview: "Pré-visualização da avaliação",
        reportHelp:
          "Selecione os filtros e clique em Exportar para exportar a avaliação.",
        from: "De",
        to: "Até",
        grazingType: "Tipo de Pastejo",
        noGrazingType: "Nenhum tipo de pastejo disponível",
        monitoringType: "Tipo de Monitoramento",
        noMonitoringType: "Nenhum tipo de monitoramento disponível",
        entryHeight: "Altura da entrada",
        exitHeight: "Altura da saída",
        occupationDays: "Dias de ocupação",
        restDays: "Dias de descanso",
        daysSuffix: "dias",
        ratingScale: "Escala de nota",
        noRatingScale: "Nenhuma escala disponível",
        entryRating: "Nota de entrada do pasto",
        exitRating: "Nota de saída do pasto",
        stripQuantity: "Quantidade em faixas",
        executionsPerDay: "Quantidade de execuções por dia",
        monitoringFrequency: "Frequência de monitoramento",
        noFrequency: "Nenhuma frequência disponível",
        selectDaysAndFirstDate: "Selecione os dias e a data da primeira tarefa",
        selectDayAndFirstDate: "Selecione o dia e a data da primeira tarefa",
        selectFirstDate: "Selecione a data da primeira tarefa",
        totalAnimals: "Total de animais",
        animalCount_one: "animal",
        animalCount_other: "animais",
      },
      productPackaging: {
        packaging: "Acondicionamento",
        bagQuantity: "Quantidade de sacos",
        bags: "sacos",
        stockBagEquivalent: "Equivalente em sacos",
        totalWeight: "Peso total",
        orderedQuantity: "Quantidade pedida",
        receivedQuantity: "Quantidade recebida",
        kgEquivalent: "Equivalente a {{value}} kg",
        bagQuantityHelp: "Qual é a quantidade de sacos do produto?",
        bagWeightRequired: "Informe um peso do saco maior que zero.",
        bagEquivalent: "Equivalente a {{value}} sacos",
      },
      tables: {
        user: "Usuário",
        task: "Tarefa",
        paddock: "Pasto",
        paddocks: "Pastos",
        batch: "Lote",
        status: "Status",
        creationDate: "Data|Criação",
        executionDate: "Data|Execução",
        synchronizationDate: "Data|Sincronização",
        date: "Data",
        managementGroup: "Grupo Manejo",
        initials: "Sigla",
        farm: "Fazenda",
        area: "Retiro",
        grazingType: "Tipo de Pastejo",
        frequency: "Frequência",
        startDate: "Data|Início",
        endDate: "Data|Final",
        paddockCount_one: "{{count}} pasto",
        paddockCount_other: "{{count}} pastos",
        classification: "Classificação",
        tradeName: "Nome comercial",
        manufacturer: "Fabricante",
        products: {
          creepFeeding: "Creep-feeding",
          creepFeedingYes: "Sim",
          creepFeedingNo: "Não",
          edit: "Editar produto {{name}}",
        },
        pastureManagement: { edit: "Editar manejo de pasto {{initials}}" },
      },
      stockManagement: {
        packagingUnavailable:
          "Não foi possível identificar o acondicionamento deste produto.",
        bagWeightUnavailable:
          "Cadastre um peso do saco maior que zero para definir o estoque.",
        invalidQuantity: "Informe uma quantidade válida maior ou igual a zero.",
        loadFailed:
          "Não foi possível carregar os dados do estoque. Abra a tela novamente para tentar de novo.",
        noProducts: "Nenhum produto neste depósito.",
        product: "Produto",
        quantity: "Quantidade",
        productFallback: "Produto #{{id}}",
        allProductsAdded: "Todos os produtos já foram adicionados.",
        selectProduct: "Selecione um produto",
        add: "Adicionar",
        loading: "Carregando estoque...",
        selectFarm: "Selecione uma fazenda",
        selectFarmHelp:
          "Os depósitos central e dos pastos serão exibidos aqui.",
        centralStorage: "Depósito central",
        productCount_one: "produto",
        productCount_other: "produtos",
        pastureStorages: "Depósitos dos pastos",
        storageCount_one: "depósito",
        storageCount_other: "depósitos",
        noRegisteredPaddocks: "Esta fazenda não possui pastos cadastrados.",
        paddock: "Pasto",
        paddockFallback: "Pasto #{{id}}",
        paddockWithoutProducts: "Pasto sem produtos",
        newStorage: "Novo depósito",
        selectPaddock: "Selecione um pasto",
        completed: "Concluído!",
        saved: "Estoque salvo com sucesso.",
        close: "Fechar",
        bags: "sacos",
        kgEquivalent: "Equivalente a {{value}} kg",
      },
      onboardingFarms: { addFarm: "+ ADICIONAR FAZENDA" },
      kmlUpload: {
        farmMap: "Mapa da fazenda",
        uploadTitle: "Upload Mapa KML",
        instructions:
          "Selecione um arquivo KML com o polígono da fazenda para carregar o mapa.",
        select: "Selecionar KML",
        replace: "Trocar KML",
        loaded: "Mapa da fazenda carregado",
        invalidFile: "Selecione um arquivo KML válido.",
        invalidCoordinates:
          "Não foi possível ler coordenadas válidas do arquivo {{file}}.",
      },
      formCards: {
        newFarm: "Nova Fazenda",
        newArea: "Novo Retiro",
        newPaddock: "Novo Pasto",
        newProfile: "Novo perfil",
        newUserHelp: "Preencha os dados do novo usuário.",
        profileNumber: "Perfil {{number}}",
        farmNumber: "Fazenda {{number}}",
        areaNumber: "Retiro {{number}}",
        paddockNumber: "Pasto {{number}}",
        profiles: "Perfis",
        profilesHelp: "Cadastre os usuários que participarão da operação.",
        onboarding: "Onboarding",
        requiredProfilesHelp:
          "É necessário cadastrar pelo menos um perfil Gerente e um perfil Capataz.",
        onboardingHelp:
          "Escolha entre cadastro manual ou importação por shapefile.",
        agriculture: "Agropecuária",
        agricultureHelp:
          "Informe se o cadastro representa uma agropecuária ou uma fazenda.",
      },
      editFooter: {
        cancel: "Cancelar",
        save: "Salvar",
        delete: "Excluir",
        back: "Voltar",
        complete: "Concluir",
      },
      messageBalloon: {
        taskCompleted: "A tarefa foi concluída?",
        taskStarted: "A tarefa foi iniciada?",
        operationType: "Qual o tipo de operação?",
        initialHourMeter: "Informar horímetro inicial",
        finalHourMeter: "Informar horímetro final",
        specificationsFollowed: "Foi realizada conforme as especificações?",
        transferType: "Qual o tipo de transferência?",
        hasFodder: "Possui forrageira?",
        fodderCoverage:
          "Qual a proporção da área coberta com planta forrageira?",
        grassHeight: "Qual a altura do capim?",
        hasWeeds: "Possui invasoras?",
        leafType: "Qual o tipo de folha?",
        weedType: "Qual o tipo de invasora?",
        weedCoverage: "Qual a cobertura de invasoras?",
        rating: "Nota",
        hasPests: "Possui pragas ou doenças?",
        hasWaterSource: "Possui aguada?",
        accessLevel: "Como é o nível de acesso?",
        needsRepair: "Precisa de reparo?",
        hasSupplementStorage: "Possui depósito de suplemento?",
        capacityKg: "Quantos quilos cabem?",
        hasTrough: "Possui cocho?",
        coveredTrough: "O cocho é coberto?",
        length: "Qual o tamanho em comprimento?",
        width: "Qual o tamanho em largura?",
        troughAccessSides: "Quantos lados possui o acesso desse cocho?",
        troughCapacity: "Qual a capacidade do cocho?",
        wireQuantity: "Qual a quantidade de fios?",
        createNewBatch: "Deseja criar um novo lote?",
        updateRoute: "Deseja incluir ou excluir um pasto na rota?",
        productOrigin:
          "Esse produto está saindo de um depósito central ou do depósito desse pasto?",
        productDestination:
          "O destino será para um cocho ou para o depósito desse pasto?",
        troughCondition: "Como está o cocho?",
        productLoss: "Houve perda de produto?",
        receivedAnimals: "Você recebeu esses animais com essas especificações?",
        receivedAnimalQuantity: "Quantidade de animais recebidos",
        saleType: "Vivo ou para abate?",
        receivedProduct: "Recebeu o Produto?",
        kilograms: "quilos",
        enterPastureHeight: "Informar a altura do pasto",
        confirmStripMovement: "Confirme a movimentação de faixa",
        enterPastureRating: "Informar a nota do pasto",
        newBatchName: "O novo lote se chamará {{name}}",
        routePaddocks: "Nesta rota estão os pastos {{paddocks}}.",
      },
      taskRequests: {
        all: "Todos",
        allTypes: "Todos os tipos",
        request: "Solicitação",
        user: "Usuário",
        type: "Tipo",
        paddock: "Pasto",
        description: "Descrição",
        status: "Status",
        noResults: "Nenhum resultado encontrado.",
        requestDate: "Data da solicitação",
        requestDateLine1: "Data da",
        requestDateLine2: "solicitação",
        createdBy: "Criada por",
        conversionDate: "Data da conversão",
        viewTask: "Ver tarefa",
        rejectionReason: "Motivo da rejeição",
        archivedAutomatically:
          "Solicitação arquivada automaticamente após 14 dias.",
        reject: "Rejeitar",
        createTask: "Criar tarefa",
        cancel: "Cancelar",
        confirm: "Confirmar",
        statuses: {
          pending: "Pendente",
          accepted: "Aceita",
          completed: "Concluída",
          rejected: "Rejeitada",
          archived: "Arquivada",
        },
      },
      inventory: {
        currentBatches: "Lotes atuais",
        correction: "Correção de inventário",
        actionError: "Ocorreu um erro na ação",
        fieldTaskRequired:
          "É necessário que o capataz realize a tarefa em campo.",
        complete: "Concluir",
        batches: "Lotes",
        male: "Macho",
        female: "Fêmea",
        bulls: "Touros",
        months: "meses",
        total: "Total",
        adjustment: "Ajuste",
        title: "Realizar inventário",
        stopTasksWarning:
          "Esta ação impossibilitará a realização de tarefas até ser finalizada pelo capataz.",
        back: "Voltar",
        next: "Avançar",
      },
      weightCategories: {
        animalEvolution: "Categoria e Evolução Animal",
        noWeights: "Não há pesos cadastrados para esta propriedade",
        category: "Categoria",
        age: "Idade",
        weight: "Peso",
        birthSeason: "Estação de nascimento",
        selectMonths: "Selecione os meses",
        noMonths: "Nenhum mês disponível",
        proportion: "Proporção {{month}}",
        proportionsTotal: "As proporções somam {{total}}%",
        parameters: "Parâmetros",
        birthWeight: "Peso ao nascimento",
        weaningWeight: "Peso à desmama (210 dias)",
        rearingDailyGain: "GMD recria",
        wetSeason: "Águas",
        drySeason: "Seca",
        adultWeight: "Peso adulto",
        male: "Macho",
        female: "Fêmea",
        selectFarm: "Selecione a fazenda",
        selectOneMonth: "Selecione pelo menos um mês",
        proportionsMustTotal: "As proporções devem somar 100%",
        nonNegative: "Não pode ser valor negativo",
        required: "Informe",
        actionError: "Ocorreu um erro na ação",
        back: "Voltar",
        maleEvolution: "Evolução de machos",
        femaleEvolution: "Evolução de fêmeas",
        ageDescription: {
          range: "de {{min}} a {{max}} meses",
          minimum: "a partir de {{min}} meses",
        },
        animalCategories: {
          female: "Fêmea",
          females: "Fêmeas",
          femaleCalf: "Bezerra",
          femaleCalves: "Bezerras",
          femaleWeaned: "Novilha",
          femaleWeanedPlural: "Novilhas",
          heifer: "Novilha",
          heifers: "Novilhas",
          cow: "Vaca",
          cows: "Vacas",
          male: "Macho",
          males: "Machos",
          maleCalf: "Bezerro",
          maleCalves: "Bezerros",
          maleWeaned: "Garrote",
          maleWeanedPlural: "Garrotes",
          youngBull: "Garrote",
          youngBulls: "Garrotes",
          steer: "Novilho",
          steers: "Novilhos",
          ox: "Boi",
          oxen: "Bois",
          bull: "Touro",
          bulls: "Touros",
        },
        months: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro",
        ],
      },
      salterUser: {
        title: "Novo usuário salgador",
        profile: "Salgador",
        required: "*Campo obrigatório não informado.",
        invalidName: "Escreva um nome válido com no mínimo 3 letras.",
        invalidPhone: "Telefone informado inválido!",
        phoneInUse: "Telefone já está sendo utilizado.",
        createError: "Não foi possível cadastrar o usuário.",
        cancel: "Cancelar",
        save: "Salvar",
      },
      notifications: {
        statuses: {
          sent: "Enviado",
          pending: "Não enviado",
          converted: "Concluído",
          cancelled: "Cancelado",
        },
      },
      dailySnapshotSupplements: {
        creepQuantity: "Suplementação em creep-feeding no cocho (kg)",
        creepClassification:
          "Classificação do produto de creep-feeding no cocho",
        creepProduct: "Produto de creep-feeding no cocho",
        stockClassifications:
          "Classificações dos produtos de salga no depósito",
        stockProducts: "Produtos de salga no depósito",
        stockQuantity: "Quantidade de suplemento de salga no depósito (kg)",
        stockCreepClassifications:
          "Classificações dos produtos de creep-feeding no depósito",
        stockCreepProducts: "Produtos de creep-feeding no depósito",
        stockCreepQuantity:
          "Quantidade de suplemento em creep-feeding no depósito (kg)",
      },
      dailySnapshotEvaluation: {
        fodders: "Forrageiras",
        fertility: "Fertilidade",
        usefulArea: "Área útil (ha)",
        levels: {
          veryHigh: "Muito alto",
          high: "Alto",
          medium: "Médio",
          low: "Baixo",
          veryLow: "Muito baixo",
        },
      },
      reports: {
        generalView: "Visualização geral",
        paddockView: "Visualização por pasto",
        average: "Média",
        averageConsumptionAnimal: "Consumo médio no período (kg/cab.dia)",
        capacity: {
          debugHectares: "Debug · Área dos retiros",
          debugAverageUa: "UA média",
          debugAverageArea: "Área média (ha)",
          debugAreaHectares: "{{name}}: {{hectares}} ha",
          debugTotalHectares: "Total: {{hectares}} ha",
          averageRate: "Lotação média (UA/ha)",
          accumulatedRainfall: "Pluviômetro acumulado (mm)",
          unavailable: "-",
          noData: "-",
          period: "Período considerado",
          periodRange: "{{start}} a {{end}}",
          days: "Dias considerados",
          season: "Estação",
          dry: "Seca",
          rainy: "Chuva",
          dailyAverages:
            "Os valores são médias diárias. A lotação mensal é a média das taxas diárias UA ÷ hectares dos retiros selecionados.",
          entry: "{{label}}: {{value}}",
          sheet: "Curva de estoque",
          filename: "mapa-gado",
          internalEntry: "Transf. interna (entrada)",
          externalEntry: "Transf. externa (entrada)",
          internalExit: "Transf. interna (saída)",
          externalExit: "Transf. externa (saída)",
          insufficientData: "Dados insuficientes para exportação",
        },
        cattleMap: "Mapa de Gado",
        overview: "Visão geral",
        batchView: "Visão de lotes",
        batchExport: {
          classification: "Etiqueta e carimbo",
          ageRange: "{{start}} a {{end}} meses",
          overAge: "> {{age}} meses",
          sheet: "Lotes por Categoria",
          filename: "lotes",
          insufficientData: "Dados insuficientes para exportação",
        },
        balance: "Balanço",
        animalCategory: "Categoria animal",
        openingBalance: "Saldo inicial",
        entry: "Entrada",
        exit: "Saída",
        evolution: "Evolução",
        periodAdjustment: "Ajuste no período",
        balanceLabel: "Saldo",
        births: "Nasc.",
        internalTransfer: "Transf. interna",
        externalTransfer: "Transf. externa",
        purchases: "Compras",
        sales: "Venda",
        deaths: "Morte",
        total: "Total",
        animalCategoryWeightUa: "Categoria animal por peso e UA",
        finalStock: "Estoque final",
        averageWeightKg: "Peso médio (Kg)",
        totalWeightKg: "Peso total (Kg)",
        totalArrobas: "Total (@s)",
        totalUa: "Total (UAs)",
        uaDistribution: "Distr. (UAs)",
        stockAndStockingCurve: "Curva de estoque e lotação",
        stockingMonth: "Lotação/mês",
        averageAnimals: "Nº médio de animais",
        averageStockingUa: "Lotação média (UAs)",
        batches: "Lotes",
        paddock: "Pasto",
        male: "Macho",
        female: "Fêmea",
        bulls: "Touros",
        months: "meses",
        select: "Selecione...",
        noOptions: "Nenhuma opção disponível",
        exportError: "Erro ao exportar dados. Tente novamente.",
        centralStorageStock: "Estoque do depósito central",
        supplementationLine: "Linha de suplementação",
        product: "Produto",
        totalStockKg: "Estoque total (Kg)",
        averageDailyOutput: "Média de saídas diárias (Kg/dia)",
        daysInStock: "Dias em estoque (dias)",
        generalAnalysis: "Análise geral",
        productClassification: "Classificação do produto",
        totalConsumption: "Consumo total no período (Kg)",
        analyzedPeriod: "Período analisado (dias)",
        averageSupplementedAnimals: "Nº médio de animais suplementados",
        supplementedAnimals: "Animais suplementados",
        averageSupplementedWeight: "Peso médio dos animais suplementados (Kg)",
        totalSupplementedWeight: "Peso total dos animais suplementados (Kg)",
        averageConsumptionKg: "Consumo médio no período (g/kgPV.dia)",
        averageConsumptionUa: "Consumo médio no período (g/UA.dia)",
        replacementFrequency: "Frequência de reposição (média de dias)",
        pastureStorageStock: "Estoque do depósito no pasto",
        supplementType: "Tipo de suplemento",
        pastureStorageQuantity: "Quantidade no depósito do pasto (Kg)",
        storageCapacity: "Capacidade total do depósito * (Kg)",
        occupiedCapacity: "% da capacidade ocupada do depósito *",
        grandTotal: "Total geral",
        evaluationValuesNote:
          "*Valores serão demonstrados após a realização de uma avaliação de pastagem",
        classification: "Classificação",
        noProducts: "Nenhum produto disponível",
        consumptionByMonth: "Consumo por mês",
        area: "Retiro",
        annualAverage: "Média anual",
        farmSum: "Somatória da fazenda",
        consumptionByBatch: "Consumo por lote",
        productName: "Nome do produto",
        grazingType: "Tipo de pastejo",
        managementGroup: "Grupo de manejo",
        instantaneousStocking: "Taxa de lotação instantânea",
        averageStockingPeriod: "Média da taxa de lotação no período",
        supplementConsumption: "Consumo de suplemento",
        averageConsumptionPeriod: "Média de consumo no período",
        accumulatedProductivity: "Produtividade acumulada",
        totalProductivityPeriod: "Total de produtividade acumulada no período",
        intervalDays: "Número de dias no intervalo: {{count}}",
        heightCollections: "Número de coletas de altura: {{count}} coletas",
        ratingCollections: "Número de coletas de nota: {{count}} coletas",
        averageOccupationDays: "Média de dias de ocupação: {{value}}",
        averageRestDays: "Média de dias de descanso: {{value}}",
        averageMonitoring: "Média de monitoramento",
        averageHeight: "Média de altura",
        averageRating: "Média de nota",
        suppliedSupplementKg: "Kg de suplemento fornecido por dia",
        suppliedSupplementAxis: "Kg de suplemento fornecido",
        continuousHeight: "Altura do pasto em manejo contínuo",
        continuousRating: "Nota do pasto em manejo contínuo",
        rotationalStocking: "Taxa de lotação instantânea em manejo rotacionado",
        rotationalHeight: "Altura do pasto em manejo rotacionado",
        rotationalRating: "Nota do pasto em manejo rotacionado",
        dailyStripChanges: "Número de mudanças de faixa diárias",
        day: "Dia",
        stockingRate: "Taxa de lotação instantânea",
      },
      carbon: {
        report: "Relatório",
        data: "Dados de carbono",
        consolidatedPeriod: "Números consolidados no período",
        consolidatedBatch: "Consolidados por lote",
        consolidatedPaddock: "Consolidados por pasto",
        batch: "Lote",
        days: "Dias",
        animals: "Número de animais",
        totalMethane: "Emissão total (kg CH4)",
        methaneAnimal: "Emissão por animal (kg CH4/cab)",
        totalCo2: "Emissão total (kg CO2 equivalente)",
        co2Animal: "Emissão por animal (kg CO2 eq/cab)",
        paddock: "Pasto",
        area: "Área",
        consumedForage: "Forragem consumida (kg MS/ha)",
        methaneArea: "Emissão por área (kg CH4/ha)",
        co2Equivalent: "kg CO2 equivalente",
        co2Area: "Emissão por área (kg CO2 eq/ha)",
      },
      excelExport: {
        title: "Relatórios",
        subtitle: "Exporte os dados para Excel",
        farmSelection: "Seleção de fazendas",
        areaSelection: "Seleção de retiros",
        selectAgriculture: "Selecionar agropecuária",
        selectAll: "Selecionar todos",
        generating: "Gerando...",
        dailyPaddock: "Diários por pasto",
        dailyBatch: "Diários por lote",
        movement: "Por movimentação",
        averageWeightKg: "Peso médio (kg)",
        selectPeriod: "Por favor, selecione um período de datas",
        selectFarmArea: "Por favor, selecione fazenda e retiro",
        generationError: "Erro ao gerar arquivo Excel. Tente novamente.",
      },
      polygonFilter: {
        farms: "Fazendas",
        allFarms: "Todas as fazendas",
        areas: "Retiros",
        allAreas: "Todos os retiros",
        searchPaddockBatch: "Pesquisar pasto ou lote",
        noPaddockBatch: "Nenhum pasto ou lote",
        foreman: "Capataz",
        manager: "Gerente",
        responsible: "Responsável",
      },
      chartUi: { dry: "Seca", rain: "Chuva" },
      commonUi: {
        yes: "Sim",
        no: "Não",
        noResults: "Nenhum resultado encontrado.",
        viewDetails: "Ver detalhes",
        archive: "Arquivar",
        delete: "Excluir",
        back: "Voltar",
        cancel: "Cancelar",
        continue: "Continuar",
        discard: "Descartar",
        edit: "Editar",
        save: "Salvar",
        close: "Fechar",
        confirm: "Confirmar",
        noOptions: "Nenhuma opção disponível",
        search: "Pesquisar",
        loading: "Carregando...",
        decreaseValue: "Diminuir valor",
        increaseValue: "Aumentar valor",
      },
      pastureHeight: {
        high: "Alto",
        ideal: "Ideal",
        low: "Baixo",
        veryLow: "Muito baixo",
      },
      mapTools: {
        undo: "Desfazer última ação",
        redo: "Refazer última ação",
        newFence: "Nova cerca",
        editFile: "Editar arquivo",
        explore: "Explorar",
        freeDraw: "Desenho livre",
        discardChanges: "Descartar alterações",
        confirmChanges: "Confirmar alterações",
        selectPaddock: "Selecione pelo menos um pasto",
        drawFenceRequired: "É necessário desenhar a nova cerca",
        drawThreePoints:
          "Desenhe uma cerca com pelo menos três pontos para continuar.",
        disconnectedPaddocks:
          "Alguns pastos não estão conectados; é necessário desenhar uma nova cerca.",
        continue: "CONTINUAR",
        fillPaddocks: "Preencha todos os campos do pasto {{numbers}}",
        confirmAll: "Confirmar todos",
        fence: "Cerca",
        fenceNavigation:
          "Você pode visualizar as informações de cada área pelas setas ou selecionando-a diretamente no mapa.",
        initials: "Sigla",
        usefulAreaQuestion: "Quantos hectares de área útil?",
        toggleFilter: "Alternar filtro",
      },
      newPassword: {
        title: "Nova senha",
        password: "Senha",
        confirmPassword: "Confirmar senha",
        success: "Senha alterada com sucesso!",
        successHelp: "Agora vamos juntos realizar seu cadastro!",
        start: "Começar",
        passwordRequired: "Informe sua senha.",
        passwordRules:
          "A senha deve ter no mínimo 6 caracteres e conter somente números.",
        repeatPassword: "Repita sua senha.",
        mismatch: "*As senhas não conferem.",
      },
      internalValidation: {
        required: "Campo obrigatório não informado.",
        selectRole: "Selecione o Cargo/Função.",
        validName: "Escreva um nome válido.",
        minName: "O nome deve ter no mínimo 3 letras.",
        invalidPhone: "Telefone informado inválido!",
        selectAgricultureFarm: "Selecione Agropecuária/Fazenda.",
        tradeNameRequired: "Nome fantasia é necessário.",
        invalidCpf: "CPF informado inválido.",
        invalidCnpj: "CNPJ informado inválido.",
        farmRequired: "Fazenda é necessária.",
        areaRequired: "Retiro é necessário.",
        paddockRequired: "Pasto é necessário.",
        paddocksRequired: "Selecione pelo menos um pasto.",
        initialsRequired: "Sigla é necessária.",
        responsibleRequired: "Responsável é necessário.",
        stateRequired: "UF é necessária.",
        cityRequired: "Cidade é necessária.",
        farmMapRequired: "O mapa da fazenda é necessário.",
        mapAreaRequired: "Selecione a fazenda para desenhar o retiro no mapa.",
        mapAvailableExceeded:
          "O espaço disponível nesta fazenda foi ultrapassado.",
        mapPaddockRequired:
          "Selecione a fazenda e o retiro para desenhar o pasto no mapa.",
        initialsLength: "O tamanho deve ser entre 1 e 3 caracteres.",
        initialsInUse: "Esta sigla já está sendo utilizada.",
        invalidNameValue: "Este nome não é válido.",
        invalidInitials: "Esta sigla não é válida.",
        maxWithCattle: "O tempo máximo com gado é necessário.",
        maxWithoutCattle: "O tempo máximo sem gado é necessário.",
        invalidMap:
          "Erro ao importar o mapa. Verifique o conteúdo do arquivo e tente novamente.",
        shapefileAttributes:
          "Informe o shapefile e todos os atributos obrigatórios.",
        farmAttribute: "Selecione o atributo da fazenda",
        areaAttribute: "Selecione o atributo do retiro",
        paddockAttribute: "Selecione o atributo do pasto",
        areaUnitAttribute: "Selecione o atributo da unidade de área",
        duplicateFarmInitials:
          "A sigla informada para a fazenda já está cadastrada!",
        finishOnboardingError: "Erro ao finalizar o onboarding.",
        profileRequired: "Selecione o Cargo/Função",
        categoryRequired: "Categoria é necessária.",
        addAnimals: "Adicione animais para essa categoria.",
        currentPaddockRequired: "O pasto atual é necessário.",
        productNameRequired: "O nome do produto é necessário.",
        manufacturerRequired: "O fabricante é necessário.",
        grazingTypeRequired: "O tipo de pastejo é necessário.",
        monitoringTypeRequired: "O tipo de monitoramento é necessário.",
        inputHeightRequired: "A altura de entrada é necessária.",
        outputHeightRequired: "A altura de saída é necessária.",
        occupationDaysRequired: "Os dias de ocupação são necessários.",
        restDaysRequired: "Os dias de descanso são necessários.",
        inputRatingRange: "A nota de entrada deve estar entre 1 e {{max}}.",
        outputRatingRange: "A nota de saída deve estar entre 1 e {{max}}.",
        outputRatingLimit:
          "A nota de saída não pode ser maior que a nota de entrada.",
        quantityRequired: "A quantidade é necessária.",
        executionsRequired: "A quantidade de execuções é necessária.",
        frequencyRequired: "O tipo de frequência é necessário.",
        expectedConsumption: "Preencha o consumo esperado.",
        supplyFrequency: "Preencha a frequência de fornecimento.",
        selectRatingScale: "Selecione a escala de nota.",
        selectStartDate: "Selecione uma data inicial.",
        createBatchError: "Erro ao criar lote.",
        deleteBatchError: "Erro ao excluir lote.",
        createManagementError: "Erro ao criar manejo de pasto.",
        loadManagementError: "Erro ao carregar manejo de pasto.",
      },
      pdfResidual: {
        yes: "Sim",
        no: "Não",
        usefulAreaEvaluation: "Avaliação de área útil",
        grassHeight: "Altura do capim",
        wireQuantity: "Quantidade de fios",
        narrowLeafRating: "% de nota de folha estreita",
        dry: "Seca",
        notDry: "Não seca",
        needsRepair: "Necessita reparo",
        noRepairNeeded: "Não necessita reparo",
        insufficientParameters:
          "Parâmetros insuficientes para renderizar o relatório.",
        loadError: "Não foi possível carregar os dados do relatório.",
      },
      taskDetails: {
        animalSale: {
          averageLiveWeight: "Peso vivo médio",
        },
        rainfall: {
          farm: "Fazenda",
          onFarm: "Na Fazenda",
          prompt: "Informe a chuva em mm",
          amount: "Chuva (mm)",
        },
        batchInventoryAdjustment: {
          area: "Retiro",
          quantity: "Quantidade",
          empty: "Não há informações de categorias disponíveis",
        },
        mergeBatches: {
          retainedBatch: "Lote mantido",
          incorporatedBatch: "Lote incorporado e inativado",
          fromPaddock: "Do pasto",
          toPaddock: "Para o pasto",
        },
        unavailable: "Tarefa indisponível",
        completed: "Concluído",
        responsible: "Responsável",
        onPaddock: "No pasto",
        fromBatch: "Do lote",
        onBatch: "No lote",
        toBatch: "Para o lote",
        fromArea: "Do retiro",
        onArea: "No retiro",
        toArea: "Para o retiro",
        paddock: "Pasto",
        evolvedFrom: "Evoluído de",
        evolvedTo: "Evoluído para",
        request: "Requisição",
        response: "Resposta",
        batch: "Lote",
        height: "Altura",
        rating: "Nota",
        pastureEvaluation: "Avaliação de pastagem",
        genus: "Gênero",
        species: "Espécie",
        photo: "Foto",
        pests: "Pragas",
        structure: "Estrutura",
        repairType: "Tipo de reparo",
        type: "Tipo",
        material: "Material",
        terrain: "Relevo",
        soil: "Solo",
        clayContent: "Teor de argila",
        fertilityLevel: "Nível de fertilidade",
        evaluated: "Avaliado",
      },
      pdfReport: {
        evaluatedItems: "Itens avaliados",
        result: "Resultado",
        paddockEvaluationResults:
          "Resultados da avaliação de pastagem por pasto",
        farm: "Fazenda",
        area: "Retiro",
        paddock: "Pasto",
        evaluatedPaddock_one: "{{count}} pasto avaliado",
        evaluatedPaddock_other: "{{count}} pastos avaliados",
        areaCount_one: "{{count}} retiro",
        areaCount_other: "{{count}} retiros",
        usefulArea: "Área útil do pasto",
        evaluator: "Avaliador",
        evaluationDay: "Dia da avaliação",
        coordinates: "Latitude - longitude",
        forage: "Forrageira",
        weeds: "Invasoras",
        pestsDiseases: "Pragas ou doenças",
        waterSource: "Aguada",
        supplement: "Suplemento",
        trough: "Cocho",
        fence: "Cerca",
        terrainSoil: "Relevo e Solo",
        photos: "Fotos",
        map: "MAPA",
        paddockReport: "Relatório por pasto",
        summary: "Sumário",
        primaryForage: "Forragem primária",
        secondaryForage: "Forragem secundária",
        tertiaryForage: "Forragem terciária",
        genus: "Gênero",
        species: "Espécie",
        broadleaf: "Folha larga",
        narrowLeaf: "Folha estreita",
        troughAccessArea: "Área de acesso ao bebedouro artificial (metros)",
        supplementStorage: "Depósito de suplementos",
        averageStorageCapacity:
          "Capacidade média dos depósitos de suplemento (kg)",
        troughs: "Cochos",
        totalSupplementationCapacity:
          "Capacidade total de suplementação da fazenda",
        troughTypes: "Tipos de cocho",
        lengthMeters: "Comprimento (metros)",
        widthMeters: "Largura (metros)",
        capacityKg: "Capacidade (kg)",
        fences: "Cercas",
        averageFenceWires: "Média da quantidade de fios das cercas",
        terrain: "Relevo",
        soil: "Solo",
        genericForage: "Forragem",
        forageGenus: "Gênero da forrageira",
        forageSpecies: "Espécie da forrageira",
        effectiveArea: "Área efetiva (ha)",
        storageCapacity: "Capacidade do depósito",
        troughCapacity: "Capacidade do cocho",
        usefulAreaCoverage: "Área útil (ha)",
        weedCoverage: "% de cobertura de invasora",
        pestsByUsefulArea: "Pragas e doenças por área útil (ha)",
        coveredTroughs: "Cochos com e sem cobertura",
        globalReport: "Relatório global",
      },
      onboardingRemaining: {
        back: "VOLTAR",
        profiles: "Perfis",
        agriculture: "Agropecuária",
        farms: "Fazendas",
        farm: "Fazenda",
        area: "Retiro",
        paddock: "Pasto",
        shapefile: "Arquivo shapefile",
        processingShapefile: "Processando shapefile...",
        farmMap: "Mapa da fazenda",
        uploadKml: "Upload do mapa KML",
        selectKml:
          "Selecione um arquivo KML com o polígono da fazenda para carregar o mapa.",
        summary: "Resumo",
        role: "Cargo/Função",
        name: "Nome",
        phone: "Telefone",
        registering: "Você está cadastrando",
        tradeName: "Nome Fantasia",
        stateRegistration: "Inscrição Estadual",
        state: "UF",
        city: "Cidade",
        address: "Endereço",
      },
      dashboardUi: {
        currentSummaryUnavailable: "—",
        lastMonth: "Último mês",
        lastSixMonths: "Últimos 6 meses",
        custom: "Personalizado",
        from: "De",
        to: "Até",
        currentAdjustment: "Ajuste atual",
        expectedBalance: "Saldo previsto",
        stocking: "Lotação (UA/ha)",
        averageStocking: "Média da taxa de lotação",
        averageHeight: "Média de altura",
        averageRating: "Média de nota",
        heightCollections: "Coletas de altura",
        ratingCollections: "Coletas de nota",
        noData: "Sem dados",
        stockingRate: "Taxa de lotação",
        averageEmissionAnimal: "Média de emissão por animal (kg CO2 eq/cab)",
        averageEmissionArea: "Média de emissão por área (kg CO2 eq/ha)",
      },
      tableUi: {
        addEvaluator: "Adicionar avaliador",
        startEvaluation: "Iniciar avaliação",
        registerFirstProduct: "Cadastre seu primeiro produto",
        registerProduct: "Cadastrar produto",
        evaluatorRequired:
          "Para iniciar a avaliação, é necessário alocar um responsável como avaliador.",
        startEvaluationHelp:
          "Inicie a avaliação para começar a visualizar os pastos avaliados.",
        noStatusResults:
          "Nenhum resultado encontrado para o estado {{status}}.",
      },
      evaluationStatus: {
        completed: "Avaliado",
        pending: "Pendente",
        canceled: "Cancelada",
        archived: "Arquivado",
      },
      managementUi: {
        selectFarm: "Selecione uma fazenda",
        noFarm: "Nenhuma fazenda encontrada",
        discardChanges: "Descartar alterações?",
        unsavedFarmChanges:
          "Existem alterações que ainda não foram salvas. Ao trocar de fazenda, elas serão descartadas.",
        continueEditing: "Continuar editando",
        somethingWrong: "Algo deu errado.",
      },
      managementDialogs: {
        tradeName: "Nome comercial",
        manufacturer: "Fabricante",
        consumption: "Consumo",
        frequency: "Frequência",
        completed: "Concluído!",
        productCreated: "Você cadastrou esse produto com sucesso!",
        backMain: "Voltar para tela principal",
        anotherProduct: "Cadastrar outro produto",
        areYouSure: "Você tem certeza?",
        deleteProductWarning: "Ao excluir, você perderá esse produto!",
        profilesAdded: "Perfis adicionados",
        profilesAddedHelp:
          "Os novos usuários foram cadastrados com a senha padrão.",
        noUsers: "Nenhum usuário cadastrado.",
        addFirstUser:
          "Clique em adicionar perfil para cadastrar o primeiro usuário.",
        deactivateManagement: "Deseja inativar este manejo de pasto?",
        noEvaluator: "Nenhum avaliador cadastrado.",
        startEvaluation: "Iniciar avaliação",
        start: "Iniciar",
        evaluationStarted: "Avaliação iniciada!",
        archiveEvaluation: "Arquivar avaliação",
        archiveEvaluationHelp:
          "Ao arquivar a avaliação, será possível solicitar uma nova avaliação de pastagem para este pasto.",
        cancelEvaluation: "Cancelar avaliação",
        cancelEvaluationHelp:
          "Ao cancelar a avaliação, a tarefa será removida do avaliador atribuído.",
      },
      taskCreation: {
        selectTask: "Selecione uma tarefa",
        back: "Voltar",
        continue: "Continuar",
        cancel: "Cancelar",
        createTask: "Criar tarefa",
        createAnother: "Criar outra tarefa",
        registerProduct: "Cadastre um produto!",
        registerProductHelp:
          "Você ainda não cadastrou um produto para criar essa tarefa. Cadastre-o através do gerenciamento do sistema.",
        products: "Produtos",
        paddockHasBatch: "Esse pasto possui lote!",
        paddockHasBatchHelp:
          "Essa tarefa não pode ser criada enquanto o pasto possuir lote. Primeiro mova o lote para outro pasto.",
        farm: "Fazenda",
        area: "Retiro",
        paddock: "Pasto",
        responsible: "Responsável",
        selectFarm: "Selecionar fazenda",
        selectResponsible: "Selecionar responsável",
        deposit: "Depósito",
        centralStorage: "Depósito central",
        selectIncomingResponsible: "Selecionar responsável pelo recebimento...",
        details: "Detalhes da tarefa (mínimo {{min}} caracteres)",
        describeTask: "Descreva a tarefa",
        completed: "Concluído!",
        success: "Você criou essa tarefa com sucesso!",
        createMore: "Criar mais uma tarefa",
        error: "Erro ao criar tarefa",
        types: {
          fertilization: "Adubação",
          detached: "Tarefa avulsa",
          waterTrough: "Bebedouros",
          fencing: "Cercas",
          contour: "Curva de nível",
          planting: "Plantio",
          soilPreparation: "Preparo de solo",
          spraying: "Pulverização",
          brushCutting: "Roçagem",
          productIncoming: "Recebimento do produto",
        },
        fields: {
          products: "Produto(s)",
          selectProducts: "Selecionar produto(s) utilizado(s)...",
          plantingType: "Tipo de plantio",
          selectPlantingType: "Selecionar o tipo de plantio...",
          genus: "Gênero",
          selectGenus: "Selecionar gênero...",
          grass: "Capim",
          selectGrass: "Selecionar capim...",
          seedType: "Tipo de sementes",
          selectSeedType: "Selecionar tipo de sementes...",
          fenceType: "Tipo de cerca",
          selectFenceType: "Selecionar tipo de cerca...",
          selectMaterial: "Selecionar material...",
          drawFence: "Desenhe a nova cerca no mapa",
          selectPaddocksMap: "Selecionar pasto(s) no mapa",
          removeFence: "Retirar cerca",
          repairFence: "Reparar cerca",
          buildFence: "Construir cerca",
          applicationType: "Tipo de aplicação",
          selectApplicationType: "Selecionar tipo de aplicação...",
          implement: "Implemento",
          selectImplement: "Selecionar implemento a ser feito no solo...",
          removeTrough: "Remover bebedouro",
          repairTrough: "Reparar bebedouro",
          installTrough: "Instalar novo bebedouro",
          format: "Formato",
          selectFormat: "Selecionar formato...",
          productClassification: "Classificação do produto",
          selectClassification: "Selecionar classificação do produto...",
          selectProduct: "Selecionar produto...",
          summary: "Resumo",
          tradeName: "Nome comercial",
          manufacturer: "Fabricante",
          consumption: "Consumo",
          frequency: "Frequência",
        },
        help: {
          activity: "Qual atividade será realizada?",
          noTroughs: "Ainda não há bebedouros no pasto selecionado",
          hasTroughs: "Já há bebedouros no pasto selecionado",
          accessSize: "Qual o tamanho da área de acesso?",
          wireQuantity: "Qual a quantidade de fios?",
          seedValue: "Qual o valor cultural (VC) da semente?",
          seedQuantity: "Qual a quantidade de semente em quilos por hectare?",
          productQuantity: "Qual a quantidade em quilo do produto?",
          fertilizerQuantity:
            "Qual a quantidade em quilo por hectare do produto?",
          moreMaterials:
            "Você pode cadastrar mais opções de material em Gerenciar sistema.",
          oneTaskPerProduct:
            "Você deve criar uma tarefa por produto. Cadastre mais produtos em Gerenciar sistema.",
        },
      },
    },
  },
  es: {
    translation: {
      shapefileForeman: {
        phoneInUse: "Este teléfono ya está en uso.",
        title: "Capataz",
        help: "Selecciona o registra al capataz de esta estancia. Se asignará como responsable de los retiros y podrás cambiarlo en cada formulario.",
        useExisting: "Utilizar capataz registrado",
        createNew: "Registrar nuevo capataz",
        select: "Selecciona un capataz",
        selectRequired: "Selecciona un capataz para continuar.",
        empty: "No hay capataces registrados. Elige registrar uno nuevo.",
        createHelp:
          "El usuario se registrará junto con el shapefile al confirmar el registro.",
      },
      shapefileImport: {
        profileName: "Nombre",
        profileRole: "Cargo/Función",
        profilePhone: "Teléfono",
        profilePassword: "Contraseña predeterminada",
        profilesToCreate: "Perfiles que se crearán ({{count}})",
        defaultPassword: "Contraseña predeterminada: {{password}}",
        noNewProfiles: "No se creará ningún perfil nuevo.",
        successTitle: "Registro completado",
        successMessage: "El registro del shapefile se completó correctamente.",
        errorTitle: "No se pudo completar el registro",
        errorMessage: "No se pudo registrar el shapefile. Inténtalo de nuevo.",
        submitting: "Enviando...",
        ok: "OK",
        otherSteps: "Otras etapas",
        importStep: "Importación",
        reviewStep: "Confirmación",
        title: "Shapefile",
        uploadHelp:
          "Importa el archivo y revisa las estancias, retiros y pasturas antes de confirmar el registro.",
        steps: "Etapas de la importación",
        loadingUsers: "Cargando responsables...",
        loadError: "No se pudieron cargar los responsables registrados.",
        noUsers:
          "Registra responsables en Perfiles antes de importar el Shapefile.",
        retry: "Intentar de nuevo",
        noFarms: "El archivo no contiene estancias para importar.",
        summary: "Estancias, retiros y pasturas ({{count}})",
        confirm: "Confirmar registro",
      },
      onboardingProperty: {
        manual: "Manual",
        addArea: "+ AGREGAR RETIRO",
        addPaddock: "+ AGREGAR PASTURA",
        farmMap: "Estancia",
        areaMaps: "Retiros ({{count}})",
        paddockMaps: "Pasturas ({{count}})",
      },
      pastureMap: {
        title: "Mapa de las estancias",
        overview: "Todas las estancias",
        navigation: "Enfocar estancia en el mapa",
        farmCount: "{{count}} estancias seleccionadas",
        farmCount_one: "{{count}} estancia seleccionada",
        farmCount_other: "{{count}} estancias seleccionadas",
        noCoordinates:
          "Esta selección no tiene coordenadas para mostrar en el mapa.",
        noFarms: "Selecciona una o más estancias para visualizar el mapa.",
        heightAxis: "Altura (cm)",
        stripAxis: "N.º de franjas",
      },

      multiDropdown: {
        selectedCount: "{{count}} seleccionados",
        remove: "Eliminar {{name}}",
      },
      reportLayout: {
        allBatches: "Todos los lotes",
        selectFilters: "Selecciona estancias y retiros",
        filters: "Filtros",
        farms: "Estancias",
        areas: "Retiros",
        period: "Período",
        updating: "Actualizando informe…",
        ready: "Datos actualizados",
        error: "No se pudo actualizar el informe",
        retry: "Intentar de nuevo",
        none: "Ninguno seleccionado",
        download: "Exportar informe",
        report: "Informe",
      },
      supplementationExport: {
        creepFeeding: "Creep-feeding",
        yes: "Sí",
        no: "No",
        mode: "Modalidad",
        normal: "Suplementación normal",
        creep: "Creep-feeding",
        unknown: "No informado",
        products: "Producto utilizado",
        classifications: "Línea de suplementación",
        quantityKg: "Cantidad (kg)",
        bags: "Equivalente en sacos",
      },
      language: {
        label: "Idioma",
        portuguese: "Portugués",
        spanish: "Español",
      },
      session: {
        title: "Inicia sesión.",
        phone: "Teléfono",
        password: "Contraseña",
        invalidCredentials: "Credenciales inválidas",
        forgotPassword: "¿Olvidaste tu contraseña?",
        forgotInstructions:
          "Ponte en contacto con el administrador de la estancia.",
        back: "VOLVER",
        continue: "Continuar",
        login: "Inicio de sesión",
        validation: {
          phone: "*¡El teléfono informado no es válido!",
          required: "*Campo obligatorio no informado.",
        },
      },
      navigation: {
        reports: "Informes",
        cattleMap: "Mapa de ganado",
        general: "General",
        batches: "Lotes",
        supplementation: "Suplementación",
        inventoryControl: "Control de inventario",
        consumptionAnalysis: "Análisis de consumo",
        monthlyConsumption: "Consumo por mes",
        pastureManagement: "Manejo de pasturas",
        byManagementGroup: "Por grupo de manejo",
        carbon: "Carbono",
        stocking: "Carga animal",
        instantStocking: "Carga instantánea",
        averageStocking: "Carga media",
        occupationAndRest: "Días de ocupación y descanso",
        management: "Manejo",
        managementType: "Tipo de manejo",
        height: "Altura",
        rating: "Nota",
        days: "Días",
        createTasks: "Crear tareas",
        requests: "Solicitudes",
        takeInventory: "Realizar inventario",
        manageSystem: "Administrar sistema",
        logout: "Salir",
        version: "Versión {{version}}",
        debugToggle:
          "Versión {{version}}. Mantén Shift presionado y haz clic cinco veces para alternar el modo debug.",
      },
      apiErrors: { invalidCredentials: "Credenciales inválidas" },
      dateFilter: {
        title: "Definir el período",
        start: "Fecha de inicio:",
        end: "Fecha de fin:",
        from: "Desde",
        to: "Hasta",
        filterAria: "Filtrar por período",
        cancel: "Cancelar",
        apply: "Aplicar",
      },
      mapLegend: {
        occupationDays: "Días de ocupación",
        restDays: "Días de descanso",
        averageStocking: "CARGA MEDIA (UA/HA)",
        instantStocking: "CARGA INSTANTÁNEA (UA/HA)",
        management: "Manejo",
        continuous: "Continuo",
        rotational: "Rotacional",
        strip: "En franjas",
        noMonitoring: "Sin monitoreo",
        height: "Altura",
        aboveHeight: "Por encima de la altura",
        withinRange: "Dentro del intervalo",
        belowHeight: "Por debajo de la altura",
        noHeight: "Sin altura asignada",
        referenceRating: "Selección de nota de referencia",
        rating: "Nota",
        aboveRating: "Por encima de la nota",
        belowRating: "Por debajo de la nota",
        noRating: "Sin nota asignada",
        aboveOccupationDays: "Por encima de los días de ocupación",
        belowOccupationDays: "Por debajo de los días de ocupación",
      },
      ratingScale: {
        bare: "rasa",
        exitPoint: "Punto de salida",
        grazingPoint: "Punto de pastoreo",
        entryPoint: "Punto de entrada",
        overgrown: "Pasado",
      },
      systemManager: {
        shapefile: "Shapefile",
        title: "Administrar sistema",
        registrations: "Registros",
        propertiesAreas: "Propiedades y áreas",
        profiles: "Perfiles",
        monitoring: "Monitoreos",
        taskMonitoring: "Monitoreo de tareas",
        pastureEvaluation: "Evaluación de pasturas",
        animals: "Animales",
        batches: "Lotes",
        pastureManagement: "Manejo de pasturas",
        categoriesWeights: "Categorías y pesos",
        batchLabels: "Etiquetas de lotes",
        supplementation: "Suplementación",
        salters: "Encargados de suplementación",
        products: "Productos",
        stock: "Inventario",
        farms: "Estancias",
        areas: "Retiros",
        paddocks: "Pasturas",
        animalCategory: "Categoría animal",
        weights: "Pesos",
        farm: "Estancia",
        area: "Retiro",
        paddock: "Pastura",
        batch: "Lote",
        selectFarm: "Selecciona la estancia",
        all: "Todos",
        evaluated: "Evaluado",
        archived: "Archivados",
        canceled: "Cancelados",
        pending: "Pendiente",
        completed: "Completado",
        syncFailure: "Error de sincronización",
        notifications: "Notificaciones",
        height: "Altura",
        days: "Días",
        rating: "Nota",
        strip: "Franja",
        startEvaluation: "Iniciar evaluación",
        active: "Activos",
        inactive: "Inactivos",
        searchSalters: "Nombre, teléfono, estancia, retiro o sigla",
        phoneUnavailable: "Teléfono no informado",
        farmCount_one: "Estancia",
        farmCount_other: "Estancias",
        areaCount_one: "Retiro",
        areaCount_other: "Retiros",
        noResults: "No se encontraron resultados.",
        titles: {
          inventory: "Realizar inventario",
          createProduct: "Registro de producto",
          manageEvaluators: "Administrar evaluadores",
          syncFailures: "Errores de sincronización",
          requests: "Solicitudes",
        },
        forms: {
          createFarm: "Registro de estancia",
          editFarm: "Edición de estancia",
          createArea: "Registro de retiro",
          editArea: "Edición de retiro",
          createPaddock: "Registro de pastura",
          editPaddock: "Edición de pastura",
          createBatch: "Creación de lotes",
          editBatch: "Edición de lote",
          editProduct: "Edición de producto",
          createManagement: "Registro de manejo de pasturas",
          editManagement: "Edición de manejo de pasturas",
          createEvaluator: "Registro de evaluador",
          editEvaluator: "Edición de evaluador",
          downloadEvaluation: "Descargar evaluación",
          viewInventory: "Ver inventario",
          linkSalter: "Vincular encargado",
          editSalter: "Editar encargado",
        },
      },
      taskMonitoring: {
        statuses: {
          completed: "Completado",
          pending: "Pendiente",
          accepted: "Aceptado",
          canceled: "Cancelado",
          error: "Error",
        },
        details: {
          liveOrSlaughter: "¿Vivo o para faena?",
          live: "Vivo",
          slaughter: "Faena",
        },
        tasks: {
          updateBatch: "Actualizar lote",
          splitBatch: "Dividir lote",
          evolveCategory: "Evolucionar categoría",
          moveBatch: "Mover lote",
          mergeBatches: "Unión de lotes",
          updateGrazingRoute: "Actualizar ruta de pastoreo",
          transferBatch: "Transferencia de lote",
          rainfallCollection: "Recolección de pluviometría",
          fertilization: "Fertilización",
          waterTrough: "Bebedero",
          fence: "Cerca",
          detached: "Tarea independiente",
          contour: "Curva de nivel",
          planting: "Siembra",
          soilPreparation: "Preparación del suelo",
          spraying: "Pulverización",
          productIncoming: "Recepción del producto",
          productDispatch: "Salida del producto",
          brushCutting: "Desmalezado",
          collectInformation: "Recolección de información",
          stripMovement: "Movimiento de franja",
          birth: "Nacimiento",
          purchase: "Compra",
          sale: "Venta",
          slaughter: "Faena",
          death: "Muerte",
          forcedInventoryEntry: "Ajuste forzado de entrada de inventario",
          forcedInventoryExit: "Ajuste forzado de salida de inventario",
          inventoryEntry: "Ajuste de entrada de inventario",
          inventoryExit: "Ajuste de salida de inventario",
          batchInventoryAdjustment: "Ajuste de inventario del lote",
        },
      },
      batchCreation: {
        initialsLoading: "Consultando la siguiente sigla del retiro…",
        initialsUnavailable:
          "No fue posible sugerir una sigla disponible. Introduce la sigla manualmente.",
      },
      batchLabel: {
        field: "Etiqueta del lote",
        placeholder: "Selecciona...",
        clear: "Limpiar selección",
        unavailable: "No se pudieron cargar las etiquetas del lote.",
        stamp: "Sello",
        stampPlaceholder: "Selecciona un sello",
        invalidLabel: "Selecciona una etiqueta válida.",
        stampRequired: "Selecciona un sello válido.",
        invalidStamp: "El sello seleccionado no está disponible.",
        updateInvalid:
          "No se pudo actualizar la etiqueta. Verifica la selección o si el lote está activo.",
        updateForbidden:
          "No tienes permiso para cambiar la etiqueta de este lote.",
        updateNotFound: "No se encontró este lote.",
        updateError:
          "No se pudo actualizar la etiqueta del lote. Inténtalo de nuevo.",
      },
      batchLabelsManagement: {
        searchLabel: "Buscar por nombre de etiqueta o por nombre o sigla de estancia y retiro",
        searchPlaceholder: "Buscar Etiqueta, Estancia y Retiro...",
        noSearchResults: "No se encontraron etiquetas para la búsqueda.",
        create: "Registrar etiqueta",
        labelName: "Nombre de la etiqueta",
        stampColumn: "Sello",
        batchCountColumn: "Lotes",
        batchCount_other: "{{formattedCount}} lotes",
        unused: "Sin uso",
        batchesTooltip_other: "{{count}} lotes: {{initials}}",
        catalog: "Catálogo de etiquetas",
        count_one: "{{count}} etiqueta registrada",
        count_other: "{{count}} etiquetas registradas",
        labelColumn: "Etiqueta",
        stampYes: "Sí",
        stampNo: "No",
        formHelp: "Ingresa el nombre de la etiqueta e indica si tendrá sello.",
        hasStamp: "Tendrá sello",
        requiredName: "Ingresa el nombre de la etiqueta.",
        nameTooLong: "El nombre debe tener hasta 255 caracteres.",
        invalid: "Revisa los datos de la etiqueta.",
        forbidden: "No tienes permiso para registrar etiquetas.",
        createError: "No se pudo registrar la etiqueta. Inténtalo de nuevo.",
        save: "Registrar",
        saving: "Registrando...",
        cancel: "Cancelar",
        close: "Cerrar registro de etiqueta",
        created: "Etiqueta registrada correctamente.",
        loading: "Cargando etiquetas...",
        loadError: "No se pudieron cargar las etiquetas.",
        retry: "Intentar de nuevo",
        empty: "No hay etiquetas registradas.",
        actions: "Acciones",
        edit: "Editar etiqueta",
        editLabel: "Editar etiqueta {{name}}",
        deleteLabel: "Eliminar etiqueta {{name}}",
        closeEdit: "Cerrar edición de etiqueta",
        editHelp:
          "Cambia el nombre o la disponibilidad del sello. El nombre guardado se usará en portugués y español.",
        saveChanges: "Guardar cambios",
        updating: "Guardando cambios...",
        updated: "Etiqueta actualizada correctamente.",
        editInvalid: "Revisa los datos de la etiqueta.",
        editConflict:
          "No se puede cambiar el sello de esta etiqueta mientras esté asociada a un lote activo.",
        editError: "No se pudo actualizar la etiqueta. Inténtalo de nuevo.",
        manageForbidden: "No tienes permiso para modificar etiquetas.",
        notFound: "No se encontró esta etiqueta.",
        deleteTitle: "Eliminar etiqueta",
        deleteHelp:
          "¿Eliminar la etiqueta {{name}} del catálogo? Permanecerá en los lotes asociados y en el historial.",
        confirmDelete: "Eliminar etiqueta",
        deleting: "Eliminando...",
        deleted: "Etiqueta eliminada del catálogo.",
        deleteError: "No se pudo eliminar la etiqueta. Inténtalo de nuevo.",
      },
      formsV2: {
        creepFeeding: "Usado en creep-feeding",
        productSummary: {
          consumption: "{{value}} g/kg de PV",
          creepFeeding: "Creep-feeding",
          yes: "Sí",
          no: "No",
          bagWeight: "Peso por saco",
          frequency: "{{frequency}} veces por semana",
        },
        cancel: "Cancelar",
        save: "Guardar",
        saveChanges: "Guardar",
        confirm: "Confirmar",
        add: "Agregar",
        export: "Exportar",
        farm: "Estancia",
        farms: "Estancias",
        area: "Retiro",
        areas: "Retiros",
        paddock: "Pastura",
        paddocks: "Pasturas",
        batch: "Lote",
        initials: "Sigla",
        mapCoordinates: "Coordenadas del mapa",
        usefulArea: "Área útil",
        totalArea: "Área total",
        farmName: "Nombre de la estancia",
        stateRegistration: "Registro estatal",
        state: "Estado",
        city: "Ciudad",
        farmManager: "Responsable de la estancia",
        seasonDefinition: "Definición de temporada",
        rainySeasonStart: "Inicio de las lluvias",
        drySeasonStart: "Inicio de la sequía",
        areaName: "Nombre del retiro",
        maxTimeWithCattle: "Tiempo máximo CON ganado",
        maxTimeWithoutCattle: "Tiempo máximo SIN ganado",
        areaManager: "Responsable del retiro",
        unusedReason: "Motivo para no utilizar la pastura",
        currentPaddock: "Pastura actual",
        category: "Categoría",
        totalUa: "UA total",
        noPaddocks: "No hay pasturas disponibles",
        weightParametersRequired:
          "Es necesario registrar los parámetros de peso",
        productTradeName: "Nombre comercial del producto",
        manufacturer: "Fabricante",
        classification: "Clasificación",
        subClassification: "Subclasificación",
        packagingType: "Tipo de acondicionamiento",
        packagingBagged: "En sacos",
        packagingBulk: "A granel",
        bagWeight: "Peso del saco",
        expectedConsumption: "Consumo esperado",
        supplyFrequency: "Frecuencia de suministro",
        timesPerWeek: "veces por semana",
        frequencies: {
          weekly: "Semanal",
          biweekly: "Quincenal",
          monthly: "Mensual",
        },
        saltType: "Tipo de sal",
        expectedConsumptionClassification: "Clasificación de consumo esperado",
        role: "Cargo/Función",
        userName: "Nombre de usuario",
        mobilePhone: "Teléfono celular",
        user: "Usuario",
        farmSelectDescription:
          "Seleccionar una estancia también selecciona todos los retiros vinculados.",
        selectFarmOrArea: "Selecciona al menos una estancia o un retiro.",
        saveSalterError: "No fue posible guardar el encargado.",
        responsible: "Responsable",
        selectResponsible: "Seleccionar responsable...",
        noResponsible: "No hay responsables disponibles",
        selectArea: "Seleccionar retiro...",
        selectPaddocks: "Seleccionar pasturas...",
        noFarms: "No hay estancias disponibles",
        noAreas: "No hay retiros disponibles",
        noPaddocksAvailable: "No hay pasturas disponibles",
        responsibleRequired: "El responsable es obligatorio.",
        areaRequired: "El retiro es obligatorio.",
        paddocksRequired: "Las pasturas son obligatorios.",
        paddocksMap: "Mapa de pasturas",
        paddocksMapHelp:
          "Selecciona uno o más pasturas para visualizar sus polígonos.",
        globalReport: "Informe global",
        paddockReport: "Informe por pastura",
        model: "Modelo",
        selectFarm: "Seleccionar estancia...",
        selectAreas: "Seleccionar retiros...",
        selectModel: "Seleccionar modelo...",
        noModel: "No hay modelos disponibles",
        farmRequired: "La estancia es obligatoria.",
        areasRequired: "Los retiros son obligatorios.",
        modelRequired: "El modelo es obligatorio.",
        reportError: "No fue posible generar el informe.",
        reportPreview: "Vista previa del informe",
        evaluationPreview: "Vista previa de la evaluación",
        reportHelp:
          "Selecciona los filtros y haz clic en Exportar para exportar la evaluación.",
        from: "Desde",
        to: "Hasta",
        grazingType: "Tipo de pastoreo",
        noGrazingType: "No hay tipos de pastoreo disponibles",
        monitoringType: "Tipo de monitoreo",
        noMonitoringType: "No hay tipos de monitoreo disponibles",
        entryHeight: "Altura de entrada",
        exitHeight: "Altura de salida",
        occupationDays: "Días de ocupación",
        restDays: "Días de descanso",
        daysSuffix: "días",
        ratingScale: "Escala de nota",
        noRatingScale: "No hay escalas disponibles",
        entryRating: "Nota de entrada de la pastura",
        exitRating: "Nota de salida de la pastura",
        stripQuantity: "Cantidad de franjas",
        executionsPerDay: "Cantidad de ejecuciones por día",
        monitoringFrequency: "Frecuencia de monitoreo",
        noFrequency: "No hay frecuencias disponibles",
        selectDaysAndFirstDate:
          "Selecciona los días y la fecha de la primera tarea",
        selectDayAndFirstDate:
          "Selecciona el día y la fecha de la primera tarea",
        selectFirstDate: "Selecciona la fecha de la primera tarea",
        totalAnimals: "Total de animales",
        animalCount_one: "animal",
        animalCount_other: "animales",
      },
      productPackaging: {
        packaging: "Acondicionamiento",
        bagQuantity: "Cantidad de sacos",
        bags: "sacos",
        stockBagEquivalent: "Equivalente en sacos",
        totalWeight: "Peso total",
        orderedQuantity: "Cantidad solicitada",
        receivedQuantity: "Cantidad recibida",
        kgEquivalent: "Equivale a {{value}} kg",
        bagQuantityHelp: "¿Cuál es la cantidad de sacos del producto?",
        bagWeightRequired: "Informa un peso del saco mayor que cero.",
        bagEquivalent: "Equivale a {{value}} sacos",
      },
      tables: {
        user: "Usuario",
        task: "Tarea",
        paddock: "Pastura",
        paddocks: "Pasturas",
        batch: "Lote",
        status: "Estado",
        creationDate: "Fecha|Creación",
        executionDate: "Fecha|Ejecución",
        synchronizationDate: "Fecha|Sincronización",
        date: "Fecha",
        managementGroup: "Grupo de manejo",
        initials: "Sigla",
        farm: "Estancia",
        area: "Retiro",
        grazingType: "Tipo de pastoreo",
        frequency: "Frecuencia",
        startDate: "Fecha|Inicio",
        endDate: "Fecha|Fin",
        paddockCount_one: "{{count}} pastura",
        paddockCount_other: "{{count}} pasturas",
        classification: "Clasificación",
        tradeName: "Nombre comercial",
        manufacturer: "Fabricante",
        products: {
          creepFeeding: "Creep-feeding",
          creepFeedingYes: "Sí",
          creepFeedingNo: "No",
          edit: "Editar producto {{name}}",
        },
        pastureManagement: { edit: "Editar manejo de pasturas {{initials}}" },
      },
      stockManagement: {
        packagingUnavailable:
          "No se pudo identificar el acondicionamiento de este producto.",
        bagWeightUnavailable:
          "Registra un peso del saco mayor que cero para definir el stock.",
        invalidQuantity: "Informa una cantidad válida mayor o igual a cero.",
        loadFailed:
          "No se pudieron cargar los datos del stock. Abre la pantalla nuevamente para volver a intentarlo.",
        noProducts: "No hay productos en este depósito.",
        product: "Producto",
        quantity: "Cantidad",
        productFallback: "Producto #{{id}}",
        allProductsAdded: "Todos los productos ya fueron agregados.",
        selectProduct: "Selecciona un producto",
        add: "Agregar",
        loading: "Cargando inventario...",
        selectFarm: "Selecciona una estancia",
        selectFarmHelp:
          "El depósito central y los depósitos de las pasturas aparecerán aquí.",
        centralStorage: "Depósito central",
        productCount_one: "producto",
        productCount_other: "productos",
        pastureStorages: "Depósitos de las pasturas",
        storageCount_one: "depósito",
        storageCount_other: "depósitos",
        noRegisteredPaddocks: "Esta estancia no tiene pasturas registrados.",
        paddock: "Pastura",
        paddockFallback: "Pastura #{{id}}",
        paddockWithoutProducts: "Pastura sin productos",
        newStorage: "Nuevo depósito",
        selectPaddock: "Selecciona una pastura",
        completed: "¡Completado!",
        saved: "Inventario guardado correctamente.",
        close: "Cerrar",
        bags: "sacos",
        kgEquivalent: "Equivale a {{value}} kg",
      },
      onboardingFarms: { addFarm: "+ AGREGAR ESTANCIA" },
      kmlUpload: {
        farmMap: "Mapa de la estancia",
        uploadTitle: "Cargar mapa KML",
        instructions:
          "Selecciona un archivo KML con el polígono de la estancia para cargar el mapa.",
        select: "Seleccionar KML",
        replace: "Cambiar KML",
        loaded: "Mapa de la estancia cargado",
        invalidFile: "Selecciona un archivo KML válido.",
        invalidCoordinates:
          "No fue posible leer coordenadas válidas del archivo {{file}}.",
      },
      formCards: {
        newFarm: "Nueva estancia",
        newArea: "Nuevo retiro",
        newPaddock: "Nuevo pastura",
        newProfile: "Nuevo perfil",
        newUserHelp: "Completa los datos del nuevo usuario.",
        profileNumber: "Perfil {{number}}",
        farmNumber: "Estancia {{number}}",
        areaNumber: "Retiro {{number}}",
        paddockNumber: "Pastura {{number}}",
        profiles: "Perfiles",
        profilesHelp: "Registra los usuarios que participarán en la operación.",
        onboarding: "Incorporación",
        requiredProfilesHelp:
          "Es necesario registrar al menos un perfil de Gerente y uno de Capataz.",
        onboardingHelp:
          "Elige entre el registro manual o la importación mediante shapefile.",
        agriculture: "Agropecuaria",
        agricultureHelp:
          "Indica si el registro representa una empresa agropecuaria o una estancia.",
      },
      editFooter: {
        cancel: "Cancelar",
        save: "Guardar",
        delete: "Eliminar",
        back: "Volver",
        complete: "Finalizar",
      },
      messageBalloon: {
        taskCompleted: "¿La tarea fue completada?",
        taskStarted: "¿La tarea fue iniciada?",
        operationType: "¿Cuál es el tipo de operación?",
        initialHourMeter: "Informar horómetro inicial",
        finalHourMeter: "Informar horómetro final",
        specificationsFollowed:
          "¿Se realizó de acuerdo con las especificaciones?",
        transferType: "¿Cuál es el tipo de transferencia?",
        hasFodder: "¿Tiene forraje?",
        fodderCoverage:
          "¿Qué proporción del área está cubierta con plantas forrajeras?",
        grassHeight: "¿Cuál es la altura del pasto?",
        hasWeeds: "¿Tiene malezas?",
        leafType: "¿Cuál es el tipo de hoja?",
        weedType: "¿Cuál es el tipo de maleza?",
        weedCoverage: "¿Cuál es la cobertura de malezas?",
        rating: "Nota",
        hasPests: "¿Tiene plagas o enfermedades?",
        hasWaterSource: "¿Tiene fuente de agua?",
        accessLevel: "¿Cómo es el nivel de acceso?",
        needsRepair: "¿Necesita reparación?",
        hasSupplementStorage: "¿Tiene depósito de suplemento?",
        capacityKg: "¿Cuántos kilogramos caben?",
        hasTrough: "¿Tiene comedero?",
        coveredTrough: "¿El comedero está cubierto?",
        length: "¿Cuál es el largo?",
        width: "¿Cuál es el ancho?",
        troughAccessSides: "¿Cuántos lados de acceso tiene este comedero?",
        troughCapacity: "¿Cuál es la capacidad del comedero?",
        wireQuantity: "¿Cuántos hilos tiene?",
        createNewBatch: "¿Desea crear un nuevo lote?",
        updateRoute: "¿Desea incluir o excluir una pastura de la ruta?",
        productOrigin:
          "¿Este producto sale de un depósito central o del depósito de esta pastura?",
        productDestination:
          "¿El destino será un comedero o el depósito de esta pastura?",
        troughCondition: "¿Cómo está el comedero?",
        productLoss: "¿Hubo pérdida de producto?",
        receivedAnimals: "¿Recibió estos animales con estas especificaciones?",
        receivedAnimalQuantity: "Cantidad de animales recibidos",
        saleType: "¿En pie o para faena?",
        receivedProduct: "¿Recibió el producto?",
        kilograms: "kilogramos",
        enterPastureHeight: "Informar la altura del pasto",
        confirmStripMovement: "Confirme el movimiento de franja",
        enterPastureRating: "Informar la nota de la pastura",
        newBatchName: "El nuevo lote se llamará {{name}}",
        routePaddocks: "En esta ruta están las pasturas {{paddocks}}.",
      },
      taskRequests: {
        all: "Todos",
        allTypes: "Todos los tipos",
        request: "Solicitud",
        user: "Usuario",
        type: "Tipo",
        paddock: "Pastura",
        description: "Descripción",
        status: "Estado",
        noResults: "No se encontraron resultados.",
        requestDate: "Fecha de la solicitud",
        requestDateLine1: "Fecha de",
        requestDateLine2: "la solicitud",
        createdBy: "Creada por",
        conversionDate: "Fecha de conversión",
        viewTask: "Ver tarea",
        rejectionReason: "Motivo del rechazo",
        archivedAutomatically:
          "Solicitud archivada automáticamente después de 14 días.",
        reject: "Rechazar",
        createTask: "Crear tarea",
        cancel: "Cancelar",
        confirm: "Confirmar",
        statuses: {
          pending: "Pendiente",
          accepted: "Aceptada",
          completed: "Completada",
          rejected: "Rechazada",
          archived: "Archivada",
        },
      },
      inventory: {
        currentBatches: "Lotes actuales",
        correction: "Corrección de inventario",
        actionError: "Ocurrió un error durante la acción",
        fieldTaskRequired:
          "Es necesario que el capataz realice la tarea en campo.",
        complete: "Finalizar",
        batches: "Lotes",
        male: "Macho",
        female: "Hembra",
        bulls: "Toros",
        months: "meses",
        total: "Total",
        adjustment: "Ajuste",
        title: "Realizar inventario",
        stopTasksWarning:
          "Esta acción impedirá realizar tareas hasta que el capataz la finalice.",
        back: "Volver",
        next: "Continuar",
      },
      weightCategories: {
        animalEvolution: "Categoría y evolución animal",
        noWeights: "No hay pesos registrados para esta propiedad",
        category: "Categoría",
        age: "Edad",
        weight: "Peso",
        birthSeason: "Estación de nacimiento",
        selectMonths: "Selecciona los meses",
        noMonths: "No hay meses disponibles",
        proportion: "Proporción {{month}}",
        proportionsTotal: "Las proporciones suman {{total}}%",
        parameters: "Parámetros",
        birthWeight: "Peso al nacer",
        weaningWeight: "Peso al destete (210 días)",
        rearingDailyGain: "GMD en recría",
        wetSeason: "Temporada de lluvias",
        drySeason: "Temporada seca",
        adultWeight: "Peso adulto",
        male: "Macho",
        female: "Hembra",
        selectFarm: "Selecciona la estancia",
        selectOneMonth: "Selecciona al menos un mes",
        proportionsMustTotal: "Las proporciones deben sumar 100%",
        nonNegative: "No puede ser un valor negativo",
        required: "Informar",
        actionError: "Ocurrió un error durante la acción",
        back: "Volver",
        maleEvolution: "Evolución de machos",
        femaleEvolution: "Evolución de hembras",
        ageDescription: {
          range: "de {{min}} a {{max}} meses",
          minimum: "a partir de {{min}} meses",
        },
        animalCategories: {
          female: "Hembra",
          females: "Hembras",
          femaleCalf: "Ternero hembra",
          femaleCalves: "Terneros hembras",
          femaleWeaned: "Destete hembra",
          femaleWeanedPlural: "Destetes hembras",
          heifer: "Vaquilla",
          heifers: "Vaquillas",
          cow: "Vaca",
          cows: "Vacas",
          male: "Macho",
          males: "Machos",
          maleCalf: "Ternero macho",
          maleCalves: "Terneros machos",
          maleWeaned: "Destete macho",
          maleWeanedPlural: "Destetes machos",
          youngBull: "Novillo o Toro",
          youngBulls: "Novillos o Toros",
          steer: "Novillo o Toro",
          steers: "Novillos o Toros",
          ox: "Novillo o Toro",
          oxen: "Novillos o Toros",
          bull: "Toro de reproducción",
          bulls: "Toros de reproducción",
        },
        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
      },
      salterUser: {
        title: "Nuevo usuario encargado de suplementación",
        profile: "Encargado de suplementación",
        required: "*Campo obligatorio no informado.",
        invalidName: "Escribe un nombre válido de al menos 3 letras.",
        invalidPhone: "¡El teléfono informado no es válido!",
        phoneInUse: "Este teléfono ya está en uso.",
        createError: "No fue posible registrar al usuario.",
        cancel: "Cancelar",
        save: "Guardar",
      },
      notifications: {
        statuses: {
          sent: "Enviado",
          pending: "No enviado",
          converted: "Completado",
          cancelled: "Cancelado",
        },
      },
      dailySnapshotSupplements: {
        creepQuantity: "Suplementación en creep-feeding en el comedero (kg)",
        creepClassification:
          "Clasificación del producto de creep-feeding en el comedero",
        creepProduct: "Producto de creep-feeding en el comedero",
        stockClassifications:
          "Clasificaciones de los productos de salga en el depósito",
        stockProducts: "Productos de salga en el depósito",
        stockQuantity: "Cantidad de suplemento de salga en el depósito (kg)",
        stockCreepClassifications:
          "Clasificaciones de los productos de creep-feeding en el depósito",
        stockCreepProducts: "Productos de creep-feeding en el depósito",
        stockCreepQuantity:
          "Cantidad de suplemento en creep-feeding en el depósito (kg)",
      },
      dailySnapshotEvaluation: {
        fodders: "Forrajeras",
        fertility: "Fertilidad",
        usefulArea: "Área útil (ha)",
        levels: {
          veryHigh: "Muy alto",
          high: "Alto",
          medium: "Medio",
          low: "Bajo",
          veryLow: "Muy bajo",
        },
      },
      reports: {
        generalView: "Vista general",
        paddockView: "Vista por pastura",
        average: "Media",
        averageConsumptionAnimal: "Consumo medio en el período (kg/cab.día)",
        capacity: {
          debugHectares: "Debug · Área de los retiros",
          debugAverageUa: "UA media",
          debugAverageArea: "Área media (ha)",
          debugAreaHectares: "{{name}}: {{hectares}} ha",
          debugTotalHectares: "Total: {{hectares}} ha",
          averageRate: "Carga media (UA/ha)",
          accumulatedRainfall: "Pluviometría acumulada (mm)",
          unavailable: "-",
          noData: "-",
          period: "Período considerado",
          periodRange: "{{start}} a {{end}}",
          days: "Días considerados",
          season: "Estación",
          dry: "Seca",
          rainy: "Lluvia",
          dailyAverages:
            "Los valores son promedios diarios. La carga mensual es el promedio de las tasas diarias UA ÷ hectáreas de los retiros seleccionados.",
          entry: "{{label}}: {{value}}",
          sheet: "Curva de inventario",
          filename: "mapa-ganado",
          internalEntry: "Transf. interna (entrada)",
          externalEntry: "Transf. externa (entrada)",
          internalExit: "Transf. interna (salida)",
          externalExit: "Transf. externa (salida)",
          insufficientData: "Datos insuficientes para exportar",
        },
        cattleMap: "Mapa de ganado",
        overview: "Vista general",
        batchView: "Vista de lotes",
        batchExport: {
          classification: "Etiqueta y sello",
          ageRange: "{{start}} a {{end}} meses",
          overAge: "> {{age}} meses",
          sheet: "Lotes por Categoría",
          filename: "lotes",
          insufficientData: "Datos insuficientes para exportar",
        },
        balance: "Balance",
        animalCategory: "Categoría animal",
        openingBalance: "Saldo inicial",
        entry: "Entrada",
        exit: "Salida",
        evolution: "Evolución",
        periodAdjustment: "Ajuste en el período",
        balanceLabel: "Saldo",
        births: "Nac.",
        internalTransfer: "Transf. interna",
        externalTransfer: "Transf. externa",
        purchases: "Compras",
        sales: "Ventas",
        deaths: "Muertes",
        total: "Total",
        animalCategoryWeightUa: "Categoría animal por peso y UA",
        finalStock: "Inventario final",
        averageWeightKg: "Peso medio (kg)",
        totalWeightKg: "Peso total (kg)",
        totalArrobas: "Total (@)",
        totalUa: "Total (UA)",
        uaDistribution: "Distrib. (UA)",
        stockAndStockingCurve: "Curva de inventario y carga animal",
        stockingMonth: "Carga/mes",
        averageAnimals: "N.º medio de animales",
        averageStockingUa: "Carga media (UA)",
        batches: "Lotes",
        paddock: "Pastura",
        male: "Macho",
        female: "Hembra",
        bulls: "Toros",
        months: "meses",
        select: "Selecciona...",
        noOptions: "No hay opciones disponibles",
        exportError: "Error al exportar los datos. Inténtalo de nuevo.",
        centralStorageStock: "Inventario del depósito central",
        supplementationLine: "Línea de suplementación",
        product: "Producto",
        totalStockKg: "Inventario total (kg)",
        averageDailyOutput: "Media de salidas diarias (kg/día)",
        daysInStock: "Días de inventario",
        generalAnalysis: "Análisis general",
        productClassification: "Clasificación del producto",
        totalConsumption: "Consumo total en el período (kg)",
        analyzedPeriod: "Período analizado (días)",
        averageSupplementedAnimals: "N.º medio de animales suplementados",
        supplementedAnimals: "Animales suplementados",
        averageSupplementedWeight:
          "Peso medio de los animales suplementados (kg)",
        totalSupplementedWeight:
          "Peso total de los animales suplementados (kg)",
        averageConsumptionKg: "Consumo medio en el período (g/kgPV.día)",
        averageConsumptionUa: "Consumo medio en el período (g/UA.día)",
        replacementFrequency: "Frecuencia de reposición (media de días)",
        pastureStorageStock: "Inventario del depósito de la pastura",
        supplementType: "Tipo de suplemento",
        pastureStorageQuantity: "Cantidad en el depósito de la pastura (kg)",
        storageCapacity: "Capacidad total del depósito * (kg)",
        occupiedCapacity: "% de capacidad ocupada del depósito *",
        grandTotal: "Total general",
        evaluationValuesNote:
          "*Los valores se mostrarán después de realizar una evaluación de pastura",
        classification: "Clasificación",
        noProducts: "No hay productos disponibles",
        consumptionByMonth: "Consumo por mes",
        area: "Retiro",
        annualAverage: "Media anual",
        farmSum: "Suma de la estancia",
        consumptionByBatch: "Consumo por lote",
        productName: "Nombre del producto",
        grazingType: "Tipo de pastoreo",
        managementGroup: "Grupo de manejo",
        instantaneousStocking: "Carga animal instantánea",
        averageStockingPeriod: "Media de la carga animal en el período",
        supplementConsumption: "Consumo de suplemento",
        averageConsumptionPeriod: "Consumo medio en el período",
        accumulatedProductivity: "Productividad acumulada",
        totalProductivityPeriod: "Productividad total acumulada en el período",
        intervalDays: "Número de días en el intervalo: {{count}}",
        heightCollections:
          "Número de mediciones de altura: {{count}} mediciones",
        ratingCollections: "Número de mediciones de nota: {{count}} mediciones",
        averageOccupationDays: "Media de días de ocupación: {{value}}",
        averageRestDays: "Media de días de descanso: {{value}}",
        averageMonitoring: "Media de monitoreo",
        averageHeight: "Altura media",
        averageRating: "Nota media",
        suppliedSupplementKg: "Kg de suplemento suministrado por día",
        suppliedSupplementAxis: "Kg de suplemento suministrado",
        continuousHeight: "Altura del pasto en manejo continuo",
        continuousRating: "Nota del pasto en manejo continuo",
        rotationalStocking: "Carga animal instantánea en manejo rotacional",
        rotationalHeight: "Altura del pasto en manejo rotacional",
        rotationalRating: "Nota del pasto en manejo rotacional",
        dailyStripChanges: "Número de cambios diarios de franja",
        day: "Día",
        stockingRate: "Carga animal instantánea",
      },
      carbon: {
        report: "Informe",
        data: "Datos de carbono",
        consolidatedPeriod: "Cifras consolidadas del período",
        consolidatedBatch: "Consolidado por lote",
        consolidatedPaddock: "Consolidado por pastura",
        batch: "Lote",
        days: "Días",
        animals: "Número de animales",
        totalMethane: "Emisión total (kg CH4)",
        methaneAnimal: "Emisión por animal (kg CH4/cab)",
        totalCo2: "Emisión total (kg CO2 equivalente)",
        co2Animal: "Emisión por animal (kg CO2 eq/cab)",
        paddock: "Pastura",
        area: "Área",
        consumedForage: "Forraje consumido (kg MS/ha)",
        methaneArea: "Emisión por área (kg CH4/ha)",
        co2Equivalent: "kg CO2 equivalente",
        co2Area: "Emisión por área (kg CO2 eq/ha)",
      },
      excelExport: {
        title: "Informes",
        subtitle: "Exporta los datos a Excel",
        farmSelection: "Selección de estancias",
        areaSelection: "Selección de retiros",
        selectAgriculture: "Seleccionar empresa agropecuaria",
        selectAll: "Seleccionar todos",
        generating: "Generando...",
        dailyPaddock: "Diarios por pastura",
        dailyBatch: "Diarios por lote",
        movement: "Por movimiento",
        averageWeightKg: "Peso medio (kg)",
        selectPeriod: "Selecciona un período de fechas",
        selectFarmArea: "Selecciona una estancia y un retiro",
        generationError:
          "Error al generar el archivo Excel. Inténtalo de nuevo.",
      },
      polygonFilter: {
        farms: "Estancias",
        allFarms: "Todas las estancias",
        areas: "Retiros",
        allAreas: "Todos los retiros",
        searchPaddockBatch: "Buscar pastura o lote",
        noPaddockBatch: "No hay pasturas ni lotes",
        foreman: "Capataz",
        manager: "Gerente",
        responsible: "Responsable",
      },
      chartUi: { dry: "Seca", rain: "Lluvia" },
      commonUi: {
        yes: "Sí",
        no: "No",
        noResults: "No se encontraron resultados.",
        viewDetails: "Ver detalles",
        archive: "Archivar",
        delete: "Eliminar",
        back: "Volver",
        cancel: "Cancelar",
        continue: "Continuar",
        discard: "Descartar",
        edit: "Editar",
        save: "Guardar",
        close: "Cerrar",
        confirm: "Confirmar",
        noOptions: "No hay opciones disponibles",
        search: "Buscar",
        loading: "Cargando...",
        decreaseValue: "Disminuir valor",
        increaseValue: "Aumentar valor",
      },
      pastureHeight: {
        high: "Alto",
        ideal: "Ideal",
        low: "Bajo",
        veryLow: "Muy bajo",
      },
      mapTools: {
        undo: "Deshacer la última acción",
        redo: "Rehacer la última acción",
        newFence: "Nueva cerca",
        editFile: "Editar archivo",
        explore: "Explorar",
        freeDraw: "Dibujo libre",
        discardChanges: "Descartar cambios",
        confirmChanges: "Confirmar cambios",
        selectPaddock: "Selecciona al menos una pastura",
        drawFenceRequired: "Es necesario dibujar la nueva cerca",
        drawThreePoints:
          "Dibuja una cerca con al menos tres puntos para continuar.",
        disconnectedPaddocks:
          "Algunos pasturas no están conectados; es necesario dibujar una nueva cerca.",
        continue: "CONTINUAR",
        fillPaddocks: "Completa todos los campos de la pastura {{numbers}}",
        confirmAll: "Confirmar todos",
        fence: "Cerca",
        fenceNavigation:
          "Puedes visualizar la información de cada área mediante las flechas o seleccionándola directamente en el mapa.",
        initials: "Sigla",
        usefulAreaQuestion: "¿Cuántas hectáreas de superficie útil?",
        toggleFilter: "Alternar filtro",
      },
      newPassword: {
        title: "Nueva contraseña",
        password: "Contraseña",
        confirmPassword: "Confirmar contraseña",
        success: "¡Contraseña actualizada correctamente!",
        successHelp: "¡Ahora vamos a completar tu registro!",
        start: "Comenzar",
        passwordRequired: "Introduce tu contraseña.",
        passwordRules:
          "La contraseña debe tener al menos 6 caracteres y contener solo números.",
        repeatPassword: "Repite tu contraseña.",
        mismatch: "*Las contraseñas no coinciden.",
      },
      internalValidation: {
        required: "Campo obligatorio no informado.",
        selectRole: "Selecciona el cargo o función.",
        validName: "Escribe un nombre válido.",
        minName: "El nombre debe tener al menos 3 letras.",
        invalidPhone: "¡El teléfono informado no es válido!",
        selectAgricultureFarm: "Selecciona actividad agropecuaria o estancia.",
        tradeNameRequired: "El nombre comercial es obligatorio.",
        invalidCpf: "El CPF informado no es válido.",
        invalidCnpj: "El CNPJ informado no es válido.",
        farmRequired: "La estancia es obligatoria.",
        areaRequired: "El retiro es obligatorio.",
        paddockRequired: "La pastura es obligatorio.",
        paddocksRequired: "Selecciona al menos una pastura.",
        initialsRequired: "La sigla es obligatoria.",
        responsibleRequired: "El responsable es obligatorio.",
        stateRequired: "El estado es obligatorio.",
        cityRequired: "La ciudad es obligatoria.",
        farmMapRequired: "El mapa de la estancia es obligatorio.",
        mapAreaRequired:
          "Selecciona la estancia para dibujar el retiro en el mapa.",
        mapAvailableExceeded:
          "Se ha superado el espacio disponible en esta estancia.",
        mapPaddockRequired:
          "Selecciona la estancia y el retiro para dibujar la pastura en el mapa.",
        initialsLength: "La longitud debe ser de 1 a 3 caracteres.",
        initialsInUse: "Esta sigla ya está en uso.",
        invalidNameValue: "Este nombre no es válido.",
        invalidInitials: "Esta sigla no es válida.",
        maxWithCattle: "El tiempo máximo con ganado es obligatorio.",
        maxWithoutCattle: "El tiempo máximo sin ganado es obligatorio.",
        invalidMap:
          "Error al importar el mapa. Verifica el contenido del archivo e inténtalo de nuevo.",
        shapefileAttributes:
          "Informa el shapefile y todos los atributos obligatorios.",
        farmAttribute: "Selecciona el atributo de la estancia",
        areaAttribute: "Selecciona el atributo del retiro",
        paddockAttribute: "Selecciona el atributo de la pastura",
        areaUnitAttribute: "Selecciona el atributo de la unidad de superficie",
        duplicateFarmInitials:
          "¡La sigla informada para la estancia ya está registrada!",
        finishOnboardingError: "Error al finalizar la incorporación.",
        profileRequired: "Selecciona el cargo o función",
        categoryRequired: "La categoría es obligatoria.",
        addAnimals: "Agrega animales a esta categoría.",
        currentPaddockRequired: "La pastura actual es obligatorio.",
        productNameRequired: "El nombre del producto es obligatorio.",
        manufacturerRequired: "El fabricante es obligatorio.",
        grazingTypeRequired: "El tipo de pastoreo es obligatorio.",
        monitoringTypeRequired: "El tipo de monitoreo es obligatorio.",
        inputHeightRequired: "La altura de entrada es obligatoria.",
        outputHeightRequired: "La altura de salida es obligatoria.",
        occupationDaysRequired: "Los días de ocupación son obligatorios.",
        restDaysRequired: "Los días de descanso son obligatorios.",
        inputRatingRange: "La nota de entrada debe estar entre 1 y {{max}}.",
        outputRatingRange: "La nota de salida debe estar entre 1 y {{max}}.",
        outputRatingLimit:
          "La nota de salida no puede ser mayor que la nota de entrada.",
        quantityRequired: "La cantidad es obligatoria.",
        executionsRequired: "La cantidad de ejecuciones es obligatoria.",
        frequencyRequired: "El tipo de frecuencia es obligatorio.",
        expectedConsumption: "Informa el consumo esperado.",
        supplyFrequency: "Informa la frecuencia de suministro.",
        selectRatingScale: "Selecciona la escala de calificación.",
        selectStartDate: "Selecciona una fecha inicial.",
        createBatchError: "Error al crear el lote.",
        deleteBatchError: "Error al eliminar el lote.",
        createManagementError: "Error al crear el manejo de pastura.",
        loadManagementError: "Error al cargar el manejo de pastura.",
      },
      pdfResidual: {
        yes: "Sí",
        no: "No",
        usefulAreaEvaluation: "Evaluación de superficie útil",
        grassHeight: "Altura del pasto",
        wireQuantity: "Cantidad de alambres",
        narrowLeafRating: "% de nota de hoja estrecha",
        dry: "Seca",
        notDry: "No seca",
        needsRepair: "Necesita reparación",
        noRepairNeeded: "No necesita reparación",
        insufficientParameters:
          "Parámetros insuficientes para renderizar el informe.",
        loadError: "No fue posible cargar los datos del informe.",
      },
      taskDetails: {
        animalSale: {
          averageLiveWeight: "Peso vivo promedio",
        },
        rainfall: {
          farm: "Estancia",
          onFarm: "En la Estancia",
          prompt: "Informe la lluvia en mm",
          amount: "Lluvia (mm)",
        },
        batchInventoryAdjustment: {
          area: "Retiro",
          quantity: "Cantidad",
          empty: "No hay información de categorías disponible",
        },
        mergeBatches: {
          retainedBatch: "Lote conservado",
          incorporatedBatch: "Lote incorporado e inactivado",
          fromPaddock: "De la pastura",
          toPaddock: "A la pastura",
        },
        unavailable: "Tarea no disponible",
        completed: "Completado",
        responsible: "Responsable",
        onPaddock: "En la pastura",
        fromBatch: "Del lote",
        onBatch: "En el lote",
        toBatch: "Al lote",
        fromArea: "Del retiro",
        onArea: "En el retiro",
        toArea: "Al retiro",
        paddock: "Pastura",
        evolvedFrom: "Evolucionado de",
        evolvedTo: "Evolucionado a",
        request: "Solicitud",
        response: "Respuesta",
        batch: "Lote",
        height: "Altura",
        rating: "Nota",
        pastureEvaluation: "Evaluación de pastura",
        genus: "Género",
        species: "Especie",
        photo: "Foto",
        pests: "Plagas",
        structure: "Estructura",
        repairType: "Tipo de reparación",
        type: "Tipo",
        material: "Material",
        terrain: "Relieve",
        soil: "Suelo",
        clayContent: "Contenido de arcilla",
        fertilityLevel: "Nivel de fertilidad",
        evaluated: "Evaluado",
      },
      pdfReport: {
        evaluatedItems: "Elementos evaluados",
        result: "Resultado",
        paddockEvaluationResults:
          "Resultados de la evaluación de pastura por pastura",
        farm: "Estancia",
        area: "Retiro",
        paddock: "Pastura",
        evaluatedPaddock_one: "{{count}} pastura evaluada",
        evaluatedPaddock_other: "{{count}} pasturas evaluadas",
        areaCount_one: "{{count}} retiro",
        areaCount_other: "{{count}} retiros",
        usefulArea: "Superficie útil de la pastura",
        evaluator: "Evaluador",
        evaluationDay: "Día de la evaluación",
        coordinates: "Latitud - longitud",
        forage: "Forrajera",
        weeds: "Malezas",
        pestsDiseases: "Plagas o enfermedades",
        waterSource: "Aguada",
        supplement: "Suplemento",
        trough: "Comedero",
        fence: "Cerca",
        terrainSoil: "Relieve y suelo",
        photos: "Fotos",
        map: "MAPA",
        paddockReport: "Informe por pastura",
        summary: "Índice",
        primaryForage: "Forraje primario",
        secondaryForage: "Forraje secundario",
        tertiaryForage: "Forraje terciario",
        genus: "Género",
        species: "Especie",
        broadleaf: "Hoja ancha",
        narrowLeaf: "Hoja estrecha",
        troughAccessArea: "Área de acceso al bebedero artificial (metros)",
        supplementStorage: "Depósito de suplementos",
        averageStorageCapacity:
          "Capacidad media de los depósitos de suplemento (kg)",
        troughs: "Comederos",
        totalSupplementationCapacity:
          "Capacidad total de suplementación de la estancia",
        troughTypes: "Tipos de comedero",
        lengthMeters: "Longitud (metros)",
        widthMeters: "Anchura (metros)",
        capacityKg: "Capacidad (kg)",
        fences: "Cercas",
        averageFenceWires: "Media de la cantidad de alambres de las cercas",
        terrain: "Relieve",
        soil: "Suelo",
        genericForage: "Forraje",
        forageGenus: "Género de la forrajera",
        forageSpecies: "Especie de la forrajera",
        effectiveArea: "Superficie efectiva (ha)",
        storageCapacity: "Capacidad del depósito",
        troughCapacity: "Capacidad del comedero",
        usefulAreaCoverage: "Superficie útil (ha)",
        weedCoverage: "% de cobertura de malezas",
        pestsByUsefulArea: "Plagas y enfermedades por superficie útil (ha)",
        coveredTroughs: "Comederos con y sin cobertura",
        globalReport: "Informe global",
      },
      onboardingRemaining: {
        back: "VOLVER",
        profiles: "Perfiles",
        agriculture: "Agropecuaria",
        farms: "Estancias",
        farm: "Estancia",
        area: "Retiro",
        paddock: "Pastura",
        shapefile: "Archivo shapefile",
        processingShapefile: "Procesando shapefile...",
        farmMap: "Mapa de la estancia",
        uploadKml: "Subir mapa KML",
        selectKml:
          "Selecciona un archivo KML con el polígono de la estancia para cargar el mapa.",
        summary: "Resumen",
        role: "Cargo/Función",
        name: "Nombre",
        phone: "Teléfono",
        registering: "Estás registrando",
        tradeName: "Nombre comercial",
        stateRegistration: "Registro estatal",
        state: "Estado",
        city: "Ciudad",
        address: "Dirección",
      },
      dashboardUi: {
        currentSummaryUnavailable: "—",
        lastMonth: "Último mes",
        lastSixMonths: "Últimos 6 meses",
        custom: "Personalizado",
        from: "Desde",
        to: "Hasta",
        currentAdjustment: "Ajuste actual",
        expectedBalance: "Saldo previsto",
        stocking: "Carga animal (UA/ha)",
        averageStocking: "Media de la carga animal",
        averageHeight: "Altura media",
        averageRating: "Nota media",
        heightCollections: "Mediciones de altura",
        ratingCollections: "Mediciones de nota",
        noData: "Sin datos",
        stockingRate: "Carga animal",
        averageEmissionAnimal: "Emisión media por animal (kg CO2 eq/cab)",
        averageEmissionArea: "Emisión media por área (kg CO2 eq/ha)",
      },
      tableUi: {
        addEvaluator: "Agregar evaluador",
        startEvaluation: "Iniciar evaluación",
        registerFirstProduct: "Registra tu primer producto",
        registerProduct: "Registrar producto",
        evaluatorRequired:
          "Para iniciar la evaluación, es necesario asignar un responsable como evaluador.",
        startEvaluationHelp:
          "Inicia la evaluación para visualizar las pasturas evaluados.",
        noStatusResults:
          "No se encontraron resultados para el estado {{status}}.",
      },
      evaluationStatus: {
        completed: "Evaluado",
        pending: "Pendiente",
        canceled: "Cancelada",
        archived: "Archivado",
      },
      managementUi: {
        selectFarm: "Selecciona una estancia",
        noFarm: "No se encontraron estancias",
        discardChanges: "¿Descartar los cambios?",
        unsavedFarmChanges:
          "Hay cambios sin guardar. Al cambiar de estancia, se descartarán.",
        continueEditing: "Continuar editando",
        somethingWrong: "Algo salió mal.",
      },
      managementDialogs: {
        tradeName: "Nombre comercial",
        manufacturer: "Fabricante",
        consumption: "Consumo",
        frequency: "Frecuencia",
        completed: "¡Completado!",
        productCreated: "¡Has registrado este producto correctamente!",
        backMain: "Volver a la pantalla principal",
        anotherProduct: "Registrar otro producto",
        areYouSure: "¿Estás seguro?",
        deleteProductWarning: "Al eliminarlo, perderás este producto.",
        profilesAdded: "Perfiles agregados",
        profilesAddedHelp:
          "Los nuevos usuarios fueron registrados con la contraseña predeterminada.",
        noUsers: "No hay usuarios registrados.",
        addFirstUser:
          "Haz clic en agregar perfil para registrar el primer usuario.",
        deactivateManagement: "¿Deseas desactivar este manejo de pastura?",
        noEvaluator: "No hay evaluadores registrados.",
        startEvaluation: "Iniciar evaluación",
        start: "Iniciar",
        evaluationStarted: "¡Evaluación iniciada!",
        archiveEvaluation: "Archivar evaluación",
        archiveEvaluationHelp:
          "Al archivar la evaluación, será posible solicitar una nueva evaluación de pastura para esta pastura.",
        cancelEvaluation: "Cancelar evaluación",
        cancelEvaluationHelp:
          "Al cancelar la evaluación, la tarea será retirada del evaluador asignado.",
      },
      taskCreation: {
        selectTask: "Selecciona una tarea",
        back: "Volver",
        continue: "Continuar",
        cancel: "Cancelar",
        createTask: "Crear tarea",
        createAnother: "Crear otra tarea",
        registerProduct: "¡Registra un producto!",
        registerProductHelp:
          "Aún no has registrado un producto para crear esta tarea. Regístralo desde la administración del sistema.",
        products: "Productos",
        paddockHasBatch: "¡Esta pastura tiene un lote!",
        paddockHasBatchHelp:
          "Esta tarea no puede crearse mientras la pastura tenga un lote. Primero mueve el lote a otra pastura.",
        farm: "Estancia",
        area: "Retiro",
        paddock: "Pastura",
        responsible: "Responsable",
        selectFarm: "Seleccionar estancia",
        selectResponsible: "Seleccionar responsable",
        deposit: "Depósito",
        centralStorage: "Depósito central",
        selectIncomingResponsible: "Seleccionar responsable de la recepción...",
        details: "Detalles de la tarea (mínimo {{min}} caracteres)",
        describeTask: "Describe la tarea",
        completed: "¡Completado!",
        success: "¡Has creado la tarea correctamente!",
        createMore: "Crear otra tarea",
        error: "Error al crear la tarea",
        types: {
          fertilization: "Fertilización",
          detached: "Tarea independiente",
          waterTrough: "Bebederos",
          fencing: "Cercas",
          contour: "Curva de nivel",
          planting: "Siembra",
          soilPreparation: "Preparación del suelo",
          spraying: "Pulverización",
          brushCutting: "Desbroce",
          productIncoming: "Recepción del producto",
        },
        fields: {
          products: "Producto(s)",
          selectProducts: "Seleccionar producto(s) utilizado(s)...",
          plantingType: "Tipo de siembra",
          selectPlantingType: "Seleccionar el tipo de siembra...",
          genus: "Género",
          selectGenus: "Seleccionar género...",
          grass: "Pasto",
          selectGrass: "Seleccionar pasto...",
          seedType: "Tipo de semillas",
          selectSeedType: "Seleccionar tipo de semillas...",
          fenceType: "Tipo de cerca",
          selectFenceType: "Seleccionar tipo de cerca...",
          selectMaterial: "Seleccionar material...",
          drawFence: "Dibuja la nueva cerca en el mapa",
          selectPaddocksMap: "Seleccionar pastura(s) en el mapa",
          removeFence: "Retirar cerca",
          repairFence: "Reparar cerca",
          buildFence: "Construir cerca",
          applicationType: "Tipo de aplicación",
          selectApplicationType: "Seleccionar tipo de aplicación...",
          implement: "Implemento",
          selectImplement: "Seleccionar implemento para el suelo...",
          removeTrough: "Retirar bebedero",
          repairTrough: "Reparar bebedero",
          installTrough: "Instalar nuevo bebedero",
          format: "Forma",
          selectFormat: "Seleccionar forma...",
          productClassification: "Clasificación del producto",
          selectClassification: "Seleccionar clasificación del producto...",
          selectProduct: "Seleccionar producto...",
          summary: "Resumen",
          tradeName: "Nombre comercial",
          manufacturer: "Fabricante",
          consumption: "Consumo",
          frequency: "Frecuencia",
        },
        help: {
          activity: "¿Qué actividad se realizará?",
          noTroughs: "Aún no hay bebederos en la pastura seleccionado",
          hasTroughs: "Ya hay bebederos en la pastura seleccionado",
          accessSize: "¿Cuál es el tamaño del área de acceso?",
          wireQuantity: "¿Cuántos hilos se utilizarán?",
          seedValue: "¿Cuál es el valor cultural (VC) de la semilla?",
          seedQuantity:
            "¿Cuál es la cantidad de semilla en kilogramos por hectárea?",
          productQuantity: "¿Cuál es la cantidad del producto en kilogramos?",
          fertilizerQuantity:
            "¿Cuál es la cantidad de producto en kilogramos por hectárea?",
          moreMaterials:
            "Puedes registrar más opciones de material en Administrar sistema.",
          oneTaskPerProduct:
            "Debes crear una tarea por producto. Registra más productos en Administrar sistema.",
        },
      },
    },
  },
} as const;
